import { AddressKind, AddressModel, ContactKind, ContractViewModel } from '@ail/contracts-api'
import {
  ApprovalStepTypeEnum,
  ApproverEmailsInputModel,
  CustomerViewModel,
  ManagerModel,
  UnitAccountViewModel,
} from '@ail/customers-api'
import { LocationViewModel } from '@ail/locations-api'
import {
  ApiException,
  ApprovalProcessConfigViewModel,
  ApprovalProcessStepKind,
  ApprovalProcessStepStatus,
  ApprovalProcessViewModel,
  FuelCardViewModel,
  NextApprovalStepInputModel,
  OrderInputModel,
  OrderType,
  OrderViewModel,
  OrdersFormFieldViewModel,
  OrdersFormViewModel,
} from '@ail/orders-api'
import React, { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ConnectedProps, connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { Arr } from '../../../helpers/Arr'
import { FrontendSettings } from '../../../helpers/FrontendSettings'
import IdIsCopied from '../../../helpers/IdIsCopied'
import { ObjectHelper } from '../../../helpers/ObjectHelper'
import { getFormTitle } from '../../../helpers/Orders'
import { PermissionManager } from '../../../helpers/PermissionManager'
import { printDate } from '../../../helpers/Utils'
import { wrapQuery } from '../../../redux/api/apiQuery'
import { contractsApi } from '../../../redux/api/contractsApi'
import { customersApi } from '../../../redux/api/customerApi'
import { locationsApi } from '../../../redux/api/locationsApi'
import { ordersApi } from '../../../redux/api/ordersApi'
import { State } from '../../../redux/reducers/initialState'
import { PL001, approvalStepsStatuses, emptyGuid, mobileVersion } from '../../../types/constants'
import { FrontendSettingsKeys, LocalstorageKeys, SpecialRequestFormField } from '../../../types/enums'
import { IExternalDataItem } from '../../../types/interfaces'
import { Orders } from '../../../utils/orders'
import { StringValidator } from '../../../utils/validator'
import Alert from '../../common/Alert/Alert'
import Confirm from '../../common/Confirm/Confirm'
import { LoadingSpinner } from '../../common/LoadingSpinner/LoadingSpinner'
import { Slider } from '../../common/Slider/Slider'
import Element from '../Elements/ElementsCases/element'
import { enabledWhen, visibleWhen } from '../Elements/common'
import { ApprovalProcessConfigSteps } from './ApprovalProcessConfigSteps/ApprovalProcessConfigSteps'
import { ApprovalProcessSteps } from './ApprovalProcessSteps/ApprovalProcessSteps'
import './RequestEdit.scss'
import { Loader } from '../../common/Loader/Loader'

const fieldValidators: Partial<Record<string, StringValidator>> = {
  DR007: new StringValidator().email(),
}

const customerSectionFieldKeys = Object.freeze({
  company: 'company',
  unit: 'unit',
  user: 'user',
})

const datePickerFieldType = 'datePick'
const datePickerAlwaysTodayWhenEmpty = 'AlwaysTodayWhenEmpty'

interface IAlertState {
  visible: boolean
  message: string
  title: string
}

interface IRouteParams {
  formId?: string
  orderId?: string
  contractId?: string
}

const requestsPageUrl = '/requests'
type OwnProps = {
  formConfigurating: boolean
  configurationForm: OrdersFormViewModel
}
type OrdersComponentProps = ConnectedProps<typeof connector> &
  WithTranslation &
  RouteComponentProps<IRouteParams> &
  OwnProps

interface OrdersComponentState {
  orders: OrderViewModel[]
  orderForms: OrdersFormViewModel[]
  approvalProcess?: ApprovalProcessViewModel
  locations: LocationViewModel[]
  customersListDispaly: boolean
  customerManagers: (ManagerModel & { ccNames: string[] })[]
  customerAddresses: AddressModel[]
  sectionsToShowInDCS: string[]
  isValue: boolean
  dcsMode: boolean
  approveConfirmed: boolean
  htmlMode: boolean
  idCopied: boolean
  copiedPopUpToggle: boolean
  currentUser: string
  companySearchString: string
  selectedCompany: {
    companyName: string
    companyId: string
  }
  selectedCostCenter?: {
    costCenterName: string
    costCenterId: string
  }
  formReadOnly: boolean
  deleteAlertState: IAlertState
  stepApprovedDownload: IAlertState
  reasonRequiredAlertState: IAlertState
  approvalStepFailAlertState: IAlertState
  loading: boolean
  approversLoading: boolean
  currentForm: OrdersFormViewModel
  validationErrors: Partial<Record<string, string[]>>
  fieldsWithAppliedInternalSource: OrdersFormFieldViewModel[] | null
  currentOrder: OrderViewModel
  currentApprovalWorflowConfigId?: string
  currentSection: string
  externalDataDict: {
    [id: string]: IExternalDataItem
  }
  sectionsDict: {
    [id: string]: boolean
  }
  costCenterList: UnitAccountViewModel[]
  costCenterDict: { [id: string]: UnitAccountViewModel }
  companyDict: { [id: string]: CustomerViewModel }
  requiredField: boolean
  noCostCentersForCompany: boolean
  noteValueToPost: string
  data: Partial<Record<string, string>>
  defaultValues: { [id: string]: string }
  showApproveConfirm: boolean
  showDeclineConfirm: boolean
  alreadyUpdatedStepAlert: IAlertState
  nothingToApprove: IAlertState
  requestWasDeletedAlert: IAlertState
  currentCompanyName: string
  submitFired: boolean
  canApproveOrder: boolean
  availableApprovalProcesses: ApprovalProcessConfigViewModel[]
  availableApprovalProcessesAdv: ApprovalProcessConfigViewModel[]
  pdfExport: boolean
  filterCompamniesByMatchingApprovalFlows: boolean
  validCompaniesForApprovalFlows: { [id: string]: boolean }
  fieldVisibility: { [id: string]: boolean }
  disabledFields: { [id: string]: boolean }
  firstStepAutoApprove: boolean
  showDeclineReasonValidation: boolean
  filteredCustomers: CustomerViewModel[]
  customersToSelect: CustomerViewModel[]
  maxFuelCards: number
  appliedInternalSource: boolean
  orderDetailsSettings: { showEmptyFields: boolean }
}

class OrdersComponent extends Component<OrdersComponentProps, OrdersComponentState> {
  private customerSearchRef: React.RefObject<HTMLDivElement> = React.createRef()
  constructor(props: OrdersComponentProps) {
    super(props)
    this.state = {
      orders: [],
      orderForms: [],
      locations: [],
      customerAddresses: [],
      customerManagers: [],
      customersListDispaly: false,
      companySearchString: '',
      isValue: false,
      sectionsToShowInDCS: [],
      customersToSelect: [],
      dcsMode: false,
      approveConfirmed: false,
      idCopied: false,
      copiedPopUpToggle: false,
      costCenterList: [],
      noCostCentersForCompany: false,
      htmlMode: false,
      requiredField: false,
      currentUser: '',
      selectedCompany: {
        companyName: '',
        companyId: '',
      },
      selectedCostCenter: {
        costCenterId: '',
        costCenterName: '',
      },
      formReadOnly: true,
      stepApprovedDownload: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      deleteAlertState: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      alreadyUpdatedStepAlert: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      requestWasDeletedAlert: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      nothingToApprove: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      reasonRequiredAlertState: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      approvalStepFailAlertState: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      loading: false,
      approversLoading: false,
      currentForm: {
        allowedForInternalUsers: false,
        ownerTenant: '',
        owner: '',
        parent: '',
        filterCompamniesByMatchingApprovalFlows: false,
        approvalWorkflows: [],
        approvalProcessConfigs: [],
        approvalWorkflowsAdv: {},
        id: '',
        name: '',
        orderType: OrderType.Generic,
        tr: {},
        genericTooltip: {},
        formFields: [],
        sections: [],
      },
      validationErrors: {},
      fieldsWithAppliedInternalSource: null,
      currentOrder: {
        id: '',
        formId: '',
        archived: false,
        userId: '',
        userName: '',
        userDisplayName: '',
        owner: '',
        created: '',
        modified: '',
        documents: [],
        data: {},
      },
      currentSection: '',
      externalDataDict: {},
      sectionsDict: {},
      noteValueToPost: '',
      data: {},
      defaultValues: {},
      showApproveConfirm: false,
      showDeclineConfirm: false,
      currentCompanyName: '',
      submitFired: false,
      canApproveOrder: false,
      availableApprovalProcesses: [],
      pdfExport: false,
      validCompaniesForApprovalFlows: {},
      fieldVisibility: {},
      filterCompamniesByMatchingApprovalFlows: false,
      firstStepAutoApprove: false,
      showDeclineReasonValidation: false,
      availableApprovalProcessesAdv: [],
      disabledFields: {},
      filteredCustomers: [],
      costCenterDict: {},
      companyDict: {},
      maxFuelCards: 0,
      appliedInternalSource: false,
      orderDetailsSettings: FrontendSettings.getObject<{ showEmptyFields: boolean }>(
        FrontendSettingsKeys.orderDetails
      ) ?? { showEmptyFields: true },
    }
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick)
    this.props.getCantons().then((res) => {
      const cantons: IExternalDataItem = {
        timeStamp: new Date().getTime(),
        data: {},
        tr: {},
      }
      res
        .toSorted((a, b) => a.name.localeCompare(b.name))
        .forEach((el) => {
          cantons.data[el.name] = el.code
          cantons.tr![el.name] = el.tr
        })
      this.setState((prev) => ({
        externalDataDict: {
          ...prev.externalDataDict,
          cantons,
        },
      }))
    })

    this.props.getLocations().then((res) => {
      const locations: IExternalDataItem = {
        timeStamp: new Date().getTime(),
        data: {},
        tr: {},
        misc: {},
      }
      res.forEach((el) => {
        locations.data[el.town] = el.postcode
        locations.tr![el.town] = el.townTr
        locations.misc![el.town] = el.canton?.code || ''
      })
      this.setState((prev) => ({
        locations: res,
        externalDataDict: {
          ...prev.externalDataDict,
          locations,
        },
      }))
    })

    const formId = this.props.match?.params?.formId
    const orderId = this.props.match?.params?.orderId
    const { history } = this.props
    if (
      window.location.pathname === `${requestsPageUrl}/new/${formId}/view=html` ||
      window.location.pathname === `${requestsPageUrl}/new/${formId}/view=dcs`
    ) {
      history.push(`${requestsPageUrl}/new/${formId}`)
    }
    if (window.location.pathname === `${requestsPageUrl}/${orderId}/view=dcs`) {
      this.setState({
        dcsMode: true,
      })
    }
    if (window.location.pathname === `${requestsPageUrl}/${orderId}/view=html`) {
      this.setState({
        htmlMode: true,
      })
    }
    this.sortCostCenters()
    sessionStorage.removeItem(LocalstorageKeys.savedUrlPath)
    this.setState({
      currentUser: this.props.user?.displayName?.replace(/  +/g, ' ') ?? '',
    })
    if (formId) {
      this.setState({
        loading: true,
      })
      this.props.getOrdersForm(formId).then(
        (form) => {
          this.setState({
            orderForms: [form],
            loading: false,
          })
        },
        () => {
          this.setState({
            loading: false,
          })
        }
      )
    }

    if (orderId) {
      this.loadFormOrder(orderId)
    }

    this.showUnits()
    if (this.props.formConfigurating && !!this.props.configurationForm) {
      if (Arr.any(this.props.configurationForm.formFields)) {
        this.setState({
          fieldsWithAppliedInternalSource: [...this.props.configurationForm.formFields],
        })
      }
      this.setState({
        currentForm: this.props.configurationForm,
        loading: false,
      })
    }
  }

  componentDidUpdate(oldProps: OrdersComponentProps, oldState: OrdersComponentState) {
    const { match, customers, location, t } = this.props
    const {
      currentForm,
      currentOrder,
      currentCompanyName,
      selectedCostCenter,
      currentUser,
      selectedCompany,
      data,
      orders,
      orderForms,
      approvalProcess,
    } = this.state
    const lang = this.props.i18n.language

    if (currentForm.formFields !== oldState.currentForm.formFields || data !== oldState.data) {
      const validatorKeys = Object.keys(fieldValidators)
      this.setState({
        validationErrors: validatorKeys.reduce((result, field) => {
          result[field] = fieldValidators[field]?.validate(data[field]).errors.map((e) => t(e))
          return result
        }, {} as Partial<Record<string, string[]>>),
      })
    }

    if (!this.props.formConfigurating) {
      const { orderId, contractId } = match.params

      if (this.state.idCopied !== oldState.idCopied) {
        if (this.state.idCopied) {
          setTimeout(() => {
            this.setState({
              idCopied: false,
            })
          }, 4000)
        } else {
          setTimeout(() => {
            this.setState({
              copiedPopUpToggle: false,
            })
          }, 500)
        }
      }

      if (this.props.match.url !== oldProps.match.url && this.props.match.url.indexOf('/view=dcs') > -1) {
        this.setState({
          dcsMode: true,
        })
      }
      if (
        this.props.match.url !== oldProps.match.url &&
        this.props.match.url.indexOf('/view=dcs') <= -1 &&
        this.state.dcsMode
      ) {
        this.setState({
          dcsMode: false,
        })
      }
      if (currentOrder !== oldState.currentOrder && currentOrder) {
        if (currentOrder.approvalProcess?.status !== 'Pending') {
          const allSteps = currentOrder.approvalProcess?.steps ?? []
          const pendingSteps = currentOrder.approvalProcess?.steps?.filter((el) => el.status === 'Pending') ?? []
          const lastStep = pendingSteps.length > 0 ? allSteps.length - pendingSteps.length : allSteps.length - 1
          currentOrder?.approvalProcess?.steps?.[lastStep]?.owners.forEach((el) => {
            if (
              el === this.props.user?.id &&
              allSteps[lastStep]?.status !== 'Pending' &&
              !this.state.approveConfirmed
            ) {
              if (allSteps[lastStep]?.status === 'Approved') {
                this.setState({
                  nothingToApprove: {
                    message: this.props.t('SELECTED_REQUEST_ALREADY_APPROVED'),
                    title: this.props.t('INFORMATION'),
                    visible: true,
                  },
                })
              }
              if (allSteps[lastStep]?.status === 'Declined') {
                this.setState({
                  nothingToApprove: {
                    message: this.props.t('SELECTED_REQUEST_ALREADY_DECLINED'),
                    title: this.props.t('INFORMATION'),
                    visible: true,
                  },
                })
              }
            }
          })
        }
      }

      if (this.props.match?.params?.formId) {
        if (orderForms !== oldState.orderForms) {
          if (orderForms.length > 0) {
            const foundCurrentForm = orderForms.find((f) => f.id === this.props.match?.params?.formId)
            if (!!foundCurrentForm && !this.state.fieldsWithAppliedInternalSource) {
              this.setState({
                currentForm: { ...foundCurrentForm },
                fieldsWithAppliedInternalSource: [...foundCurrentForm.formFields],
                submitFired: false,
                formReadOnly: !this.props.user?.canManageOrders,
              })

              const defaultSections = foundCurrentForm.sections.filter((s) => s.default)

              const defaultSectionsByExternalTrigger = foundCurrentForm.sections.filter(
                (s) => s.defaultByExternalTrigger
              )

              const defaultSection =
                defaultSectionsByExternalTrigger.length > 0
                  ? defaultSectionsByExternalTrigger[0]
                  : defaultSections.length > 0
                  ? defaultSections[0]
                  : null

              if (contractId) {
                this.loadContractAndPrefill(contractId, true)

                if (defaultSection) {
                  setTimeout(() => {
                    this.setState({
                      currentSection: defaultSection.name,
                    })
                  }, 500)
                }
              } else if (this.props.customers?.length === 1) {
                const theOnlyCustomer = this.props.customers[0]
                const theOnlyUnit = theOnlyCustomer.units?.length === 1 ? theOnlyCustomer.units.at(0) : undefined
                this.selectedCompanyById(theOnlyCustomer.id)
                if (theOnlyUnit) {
                  setTimeout(() => {
                    this.selectedCostCenterById(theOnlyUnit.id)
                  }, 100)
                }
              }
            } else {
              this.props.history.push(requestsPageUrl)
            }
          }
        }

        if (orders !== oldState.orders && !contractId) {
          this.fillFormWithOrderData()
        }

        if (currentForm !== oldState.currentForm) {
          this.fillDefaultValues()
        }

        if (customers !== oldProps.customers || currentForm !== oldState.currentForm) {
          this.updateFilteredCustomers()
        }
      }

      if (currentForm?.formFields?.length !== oldState.currentForm?.formFields?.length) {
        const rawData: { [id: string]: string } = {}
        currentForm?.formFields.forEach((field) => {
          const { name } = field
          if (field.defaultValue) {
            rawData[name] = field.defaultValue
          }
        })
        this.setState({
          defaultValues: rawData,
        })
      }

      if (selectedCostCenter !== oldState.selectedCostCenter && currentOrder) {
        this.setState({
          currentOrder: {
            ...currentOrder,
            costCenter: selectedCostCenter,
          },
        })
      }

      if (currentUser !== oldState.currentUser && currentOrder) {
        this.setState({
          currentOrder: {
            ...currentOrder,
            userDisplayName: currentUser,
          },
        })
      }

      if (
        !!location.pathname &&
        location.pathname.indexOf('/view=html') === -1 &&
        location.pathname !== oldProps.location.pathname
      ) {
        this.setState({
          htmlMode: false,
        })
      }

      if (
        (this.state.dcsMode !== oldState.dcsMode && this.state.dcsMode && !!currentForm) ||
        (currentForm !== oldState.currentForm && !!currentForm && this.state.dcsMode)
      ) {
        const sectionsToShow: string[] = []
        sectionsToShow.push('approve')
        if (!!selectedCompany?.companyId || !!selectedCostCenter?.costCenterId || !!currentUser) {
          sectionsToShow.push('customer')
        }
        currentForm?.formFields.map((el) => {
          if (!!data[el.name] && !sectionsToShow.includes(el.section)) {
            sectionsToShow.push(el.section)
          }
        })
        this.setState({
          sectionsToShowInDCS: sectionsToShow,
        })
      }

      if (
        !!location.pathname &&
        location.pathname.indexOf('/view=dcs') === -1 &&
        location.pathname !== oldProps.location.pathname
      ) {
        this.setState({
          dcsMode: false,
          sectionsToShowInDCS: [],
          isValue: false,
        })
      }

      if (orderId) {
        if (orders.length === 0 && orders !== oldState.orders) {
          this.props.history.push(requestsPageUrl)
        }
        if (
          !!approvalProcess &&
          !!currentOrder?.approvalProcess &&
          approvalProcess !== currentOrder?.approvalProcess &&
          approvalProcess.id === currentOrder.approvalProcess.id
        ) {
          this.setState({
            currentOrder: { ...currentOrder, approvalProcess },
          })
        }

        if (
          ((orders !== oldState.orders && orders.length > 0) ||
            (orderForms !== oldState.orderForms && orderForms.length > 0)) &&
          Arr.any(orders) &&
          Arr.any(orderForms) &&
          orderForms?.length === 1
        ) {
          this.initFormByOrder(orderId, orders, orderForms)
        }

        if (currentOrder !== oldState.currentOrder) {
          this.setState({
            submitFired: false,
          })

          this.fillDefaultValues()
        }
      }
      if (oldState.currentForm !== currentForm && currentForm && orderForms.length) {
        const approvalProcessConfig = currentForm.approvalProcessConfigs.find((c) => c.steps?.at(0)?.autoApprove)

        const firstStepAutoApprove = !!approvalProcessConfig

        this.setState({
          firstStepAutoApprove,
          currentSection: currentForm.sections.length > 0 ? currentForm.sections[0].name : '',
        })
      }

      if (
        (oldState.currentForm !== currentForm && !!currentForm && orderForms.length > 0) ||
        selectedCompany !== oldState.selectedCompany
      ) {
        const validApprovalProcessesForCurrentCompany = currentForm?.approvalProcessConfigs?.filter((ap) =>
          ap.validCompanies?.includes(selectedCompany.companyId)
        )

        const validCompaniesForApprovalFlows: { [id: string]: boolean } = {}

        currentForm?.approvalProcessConfigs
          ?.filter((c) => c.validCompanies?.length)
          .forEach((c) => {
            c.validCompanies?.forEach((vc) => {
              validCompaniesForApprovalFlows[vc] = true
            })
          })

        const filterCompamniesByMatchingApprovalFlows = currentForm?.filterCompamniesByMatchingApprovalFlows || false

        const availableApprovalProcesses =
          !!validApprovalProcessesForCurrentCompany && validApprovalProcessesForCurrentCompany.length > 0
            ? validApprovalProcessesForCurrentCompany
            : currentForm?.approvalProcessConfigs || []
        this.setState({
          availableApprovalProcesses,
          availableApprovalProcessesAdv: [],
          validCompaniesForApprovalFlows,
          filterCompamniesByMatchingApprovalFlows,
        })
      }

      if (
        this.state.availableApprovalProcesses !== oldState.availableApprovalProcesses ||
        data !== oldState.data ||
        this.state.selectedCompany !== oldState.selectedCompany ||
        (this.state.selectedCostCenter !== oldState.selectedCostCenter &&
          !!currentForm?.approvalWorkflowsAdv &&
          Object.keys(currentForm?.approvalWorkflowsAdv).length > 0)
      ) {
        this.updateAvailableApprovalProcessesFromAdvancedConfig()
      }

      if (currentCompanyName !== oldState.currentCompanyName) {
        this.showUnits()
      }
      if (
        this.state.loading !== oldState.loading &&
        !this.state.loading &&
        this.state.htmlMode &&
        window.location.href.indexOf('view=html') > -1
      ) {
        document.title = `I4U_${Orders.getFormTitle(currentForm, lang, true)}_${this.state.currentOrder?.id}`
        setTimeout(() => {
          window.print()
        }, 1000)
      }
      if (this.state.pdfExport !== oldState.pdfExport && window.location.href.indexOf('view=pdf') > -1) {
        setTimeout(() => {
          this.exportToPDF()
        }, 1000)
      }
    }
    if (this.state.companySearchString !== oldState.companySearchString && !!this.state.companySearchString) {
      const customersToSelect = this.state.filteredCustomers.filter(
        (el) => el.name.toLowerCase().indexOf(this.state.companySearchString.toLowerCase()) > -1
      )
      this.setState({
        customersToSelect,
      })
    }
    if (selectedCompany !== oldState.selectedCompany) {
      this.sortCostCenters()
      this.setState({
        currentOrder: {
          ...currentOrder,
          company: selectedCompany,
        },
      })

      if (this.state.selectedCompany.companyId) {
        this.loadManagers()
      } else {
        this.setState({
          customerManagers: [],
          customerAddresses: [],
        })
      }
      if (!!this.props.match?.params?.orderId && orders.length === 1) {
        this.setState({
          selectedCostCenter: orders[0].costCenter,
        })
      } else {
        this.setState({
          selectedCostCenter: {
            costCenterId: '',
            costCenterName: '',
          },
        })
      }
    }
    if (
      this.props.customers !== oldProps.customers ||
      this.state.currentForm !== oldState.currentForm ||
      this.state.currentOrder !== oldState.currentOrder ||
      this.state.filterCompamniesByMatchingApprovalFlows !== oldState.filterCompamniesByMatchingApprovalFlows ||
      this.state.validCompaniesForApprovalFlows !== oldState.validCompaniesForApprovalFlows
    ) {
      this.updateFilteredCustomers()
    }
    if (this.state.currentForm !== oldState.currentForm && this.state.currentForm?.ownerTenant) {
      this.props.getTenantFuelCardSet(this.state.currentForm.ownerTenant).then(
        (set) => {
          this.updateFuelCards(set.fuelCards ?? [], set.maxFuelCards)
        },
        () => {
          this.updateFuelCardsFromDefaultSource()
        }
      )
    }
    if (this.props.configurationForm !== oldProps.configurationForm && !!this.props.configurationForm) {
      this.setState({
        currentForm: this.props.configurationForm,
        formReadOnly: !this.props.user?.canManageOrders,
      })
      if (Arr.any(this.props.configurationForm.formFields)) {
        this.setState({
          fieldsWithAppliedInternalSource: [...this.props.configurationForm.formFields],
        })
      }
      this.updateVisibility()
    }
    if (oldState.currentForm !== this.state.currentForm && this.state.currentForm && this.state.orderForms.length > 0) {
      const approvalProcessConfig = this.state.currentForm?.approvalProcessConfigs?.find(
        (c) => c.steps?.at(0)?.autoApprove
      )

      const firstStepAutoApprove = !!approvalProcessConfig

      this.setState({
        firstStepAutoApprove,
        currentSection: this.state.currentForm?.sections?.length > 0 ? this.state.currentForm?.sections[0]?.name : '',
      })
    }
    if (data !== oldState.data) {
      this.updateVisibility(oldState.data)
      if (this.state.submitFired) {
        const sectionsDict = { ...this.state.sectionsDict }
        const formfields: string[] = []
        const formfieldsOK: string[] = []
        this.state.currentForm.formFields.map((s) => {
          if (
            (s.required && !this.state.data[s.name]) ||
            (s.required && s.type === 'checkBox' && this.state.data[s.name] !== 'true')
          ) {
            Object.keys(s.visibleWhen).forEach((el) => {
              const val = this.state.data[el]
              if ((val != null && s.visibleWhen[el].includes(val)) || !el) {
                formfields.push(s.section)
              }
            })
            if (Object.keys(s.visibleWhen).length === 0) {
              formfields.push(s.section)
            }
          }
        })
        this.state.currentForm.formFields.map((s) => {
          if (s.required && this.state.data[s.name] && formfields.indexOf(s.section) <= -1) {
            formfieldsOK.push(s.section)
          }
        })
        formfields.filter((value, index, self) => self.indexOf(value) === index).map((el) => (sectionsDict[el] = true))

        formfieldsOK
          .filter((value, index, self) => self.indexOf(value) === index)
          .map((el) => (sectionsDict[el] = false))
        this.setState({
          sectionsDict,
        })
      }
    }
  }

  public handleChangeInput(
    id: string,
    event?: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    tooBig?: boolean,
    specialRequestFormField?: SpecialRequestFormField
  ) {
    const { currentForm: element } = this.state

    const field = element.formFields.find((f) => f.name === id)

    if (field) {
      const { type, name } = field

      this.setState((prev) => {
        let data = { ...prev.data }
        if (event) {
          switch (type) {
            case 'upload': {
              if (event.target && 'files' in event.target) {
                this.changeFile(element, data, name, event.target.files![0], tooBig)
              } else {
                data[name] = undefined
              }
              break
            }
            default:
              data[name] = event.target.value !== null ? event.target.value?.toString() : undefined
              data = this.getFieldIfExistFromInternalSource(field, data)

              switch (specialRequestFormField) {
                case SpecialRequestFormField.CustomersSelect:
                  this.selectedCompanyById(event.target.value)
                  break
                case SpecialRequestFormField.CustomersSelectUnlinked:
                  this.filterUnitsByUnlinkedCustomerId(event.target.value)
                  break
                case SpecialRequestFormField.UnitsSelect:
                  this.selectedCostCenterById(event.target.value)
                  break
                default:
                  break
              }
              break
          }
        } else {
          delete data[name]
        }
        return {
          data,
          currentForm: element,
          currentCompanyName: data.CU001 ?? '',
        }
      })
    }
  }

  private getFieldIfExistFromInternalSource(
    source: OrdersFormFieldViewModel,
    data: Partial<Record<string, string>>,
    optionsApplyOnly: boolean = false
  ): Partial<Record<string, string>> {
    const fieldsWithAppliedInternalSource = ObjectHelper.clone(this.state.fieldsWithAppliedInternalSource)
    const currentForm = this.state.currentForm
    if (!fieldsWithAppliedInternalSource || !currentForm) {
      return data
    }

    const newData = { ...data }

    for (let key = 0; key < currentForm.formFields.length; key++) {
      const value = currentForm.formFields[key]
      if (!!value.internalSource && Arr.any(Object.keys(value.internalSource.triggerFields))) {
        const triggerField = Arr.firstOrDefault(
          Object.entries(value.internalSource.triggerFields).filter((a) => a[0] === source.name)
        )
        if (triggerField) {
          const triggerValue = triggerField[1]
          const val = data[source.name]
          if (
            val != null &&
            triggerValue
              .split('|')
              .map((item) => item.trim())
              .includes(val)
          ) {
            // Set new options
            if (
              value?.internalSource?.newData?.options &&
              Arr.any(Object.keys(value?.internalSource?.newData?.options))
            ) {
              fieldsWithAppliedInternalSource[key].options = [...value.internalSource.newData.options]
            }

            // Set default value
            if (!!value.internalSource.newData?.defaultValue && !optionsApplyOnly) {
              newData[fieldsWithAppliedInternalSource[key].name] = value.internalSource.newData?.defaultValue
            }
            // Set display mode
            if (value.internalSource.newData?.disabled) {
              fieldsWithAppliedInternalSource[key].disabled = value.internalSource.newData?.disabled
            }

            // Set fuel card limit
            if (value.internalSource.newData?.fuelCardsLimit) {
              fieldsWithAppliedInternalSource[key].fuelCardsLimit = value.internalSource.newData?.fuelCardsLimit
            }

            // Set minimum value
            if (value.internalSource.newData?.minimumValue) {
              fieldsWithAppliedInternalSource[key].minimumValue = value.internalSource.newData?.minimumValue
            }

            // Set maximum value
            if (value.internalSource.newData?.maximumValue) {
              fieldsWithAppliedInternalSource[key].maximumValue = value.internalSource.newData?.maximumValue
            }

            // Set step
            if (value.internalSource.newData?.step) {
              fieldsWithAppliedInternalSource[key].step = value.internalSource.newData?.step
            }

            if (value.internalSource.newData?.externalDataSourceName) {
              fieldsWithAppliedInternalSource[key].externalDataSourceName =
                value.internalSource.newData?.externalDataSourceName
            }
          } else {
            fieldsWithAppliedInternalSource[key].externalDataSourceName =
              currentForm.formFields[key].externalDataSourceName
            fieldsWithAppliedInternalSource[key].options = currentForm.formFields[key].options
            fieldsWithAppliedInternalSource[key].disabled = currentForm.formFields[key].disabled
            fieldsWithAppliedInternalSource[key].defaultValue = currentForm.formFields[key].defaultValue
            fieldsWithAppliedInternalSource[key].fuelCardsLimit = currentForm.formFields[key].fuelCardsLimit
            fieldsWithAppliedInternalSource[key].minimumValue = currentForm.formFields[key].minimumValue
            fieldsWithAppliedInternalSource[key].maximumValue = currentForm.formFields[key].maximumValue
            fieldsWithAppliedInternalSource[key].step = currentForm.formFields[key].step
          }

          this.setState({ fieldsWithAppliedInternalSource })
        }
      }
    }
    return newData
  }

  render() {
    const {
      fieldsWithAppliedInternalSource,
      currentForm,
      currentOrder,
      currentApprovalWorflowConfigId,
      currentSection,
      externalDataDict,
      data,
      fieldVisibility,
      loading,
      deleteAlertState,
      reasonRequiredAlertState,
      approvalStepFailAlertState,
      submitFired,
      formReadOnly,
      selectedCompany,
      currentUser,
      selectedCostCenter,
      canApproveOrder,
      availableApprovalProcesses,
      availableApprovalProcessesAdv,
      costCenterList,
      filterCompamniesByMatchingApprovalFlows,
      firstStepAutoApprove,
      showDeclineReasonValidation,
      alreadyUpdatedStepAlert,
      requestWasDeletedAlert,
      nothingToApprove,
      noCostCentersForCompany,
      disabledFields,
      filteredCustomers,
      maxFuelCards,
      appliedInternalSource,
      orderDetailsSettings,
    } = this.state

    const availableApprovalProcessesToUse =
      availableApprovalProcessesAdv.length > 0
        ? availableApprovalProcessesAdv
        : availableApprovalProcesses?.filter((el) => !currentForm?.approvalWorkflowsAdv[el.id])
    const { user, t, i18n, match } = this.props
    const lang = this.props.i18n.language
    const changeTrigger = (arg0: ContractViewModel) => this.loadContractAndPrefill(arg0.id)
    const prefillManagerContacts = (arg: ManagerModel) => this.prefillManagerContacts(arg)
    const removeCompanyAddress = () => this.removeCompanyAddress()
    const searchStringDeleted = () => this.searchStringDeleted()
    const formFields: OrdersFormFieldViewModel[] = []
    const customerSectionFormFields: OrdersFormFieldViewModel[] = []
    const customerSectionFields: { [id: string]: OrdersFormFieldViewModel } = {}
    const customerSection = currentForm.sections.find((s) => s.name === 'customer')

    fieldsWithAppliedInternalSource?.forEach((f) => {
      if (f.section === 'customer') {
        customerSectionFields[f.name] = f
        if (!(f.name in customerSectionFieldKeys)) {
          customerSectionFormFields.push(f)
        }
      } else {
        formFields.push(f)
      }
    })

    const canAppove = currentOrder && (canApproveOrder || user?.isAdmin)

    const approvalProcessesForDropDown =
      currentOrder && !!currentOrder?.approvalProcess?.id
        ? currentForm?.approvalProcessConfigs.filter((c) => c.id === currentOrder.approvalProcessConfigId)
        : availableApprovalProcessesToUse.filter((ap) =>
            filterCompamniesByMatchingApprovalFlows ? ap.validCompanies?.length : true
          )

    const genericTooltip = Orders.getFormGenericTooltip(currentForm, lang)
    const customersToDisplay = this.state.companySearchString
      ? filteredCustomers.filter((cust) => {
          if (cust.name.toLowerCase().indexOf(this.state.companySearchString.toLowerCase()) > -1) {
            return cust
          }
        })
      : filteredCustomers.filter((el, i) => {
          if (i < 10 && !!el) {
            return el
          }
        })
    const ordersSteps = currentOrder?.approvalProcess?.steps?.length
      ? currentOrder?.approvalProcess?.steps
      : currentOrder?.approvalProcess?.stepsWithTags

    const currentApprovalProcessConfig = availableApprovalProcessesToUse.find(
      (ap) =>
        (!!currentApprovalWorflowConfigId && ap.id === currentApprovalWorflowConfigId) ||
        !filterCompamniesByMatchingApprovalFlows ||
        ap.validCompanies?.length
    )

    return (
      <Loader blocking={loading || this.state.approversLoading}>
        {currentForm ? (
          <>
            <div
              className="orders-component"
              style={!(this.state.htmlMode || this.state.dcsMode) ? { visibility: 'visible' } : { display: 'none' }}
            >
              <div
                style={mobileVersion ? { flexDirection: 'column', minWidth: 'auto', maxWidth: 'none' } : undefined}
                className="ordersArea"
              >
                <div className="ordersFormArea">
                  <div style={mobileVersion ? { width: '100%' } : undefined} className="ordersFormTitle">
                    <div className="iconAndTitle">
                      <i className={currentForm.icon} />
                      <span>
                        {`${getFormTitle(currentForm, lang, true) || currentForm.name} `}
                        {currentApprovalWorflowConfigId && t('REQUEST')}
                      </span>
                      {!!genericTooltip && (
                        <div className="tooltipArea">
                          <i className="icon-info" />
                          <div className="generic-tooltip">{genericTooltip}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={mobileVersion ? { width: '100%' } : undefined} className="ordersForm">
                    {formFields.map(
                      (field, i) =>
                        !field.isHiddenOnForm && (
                          <Element
                            key={i}
                            field={{
                              ...field,
                              index: i,
                              minimumValue: field.minimumValue,
                              maximumValue: field.maximumValue,
                              step: field.step,
                              data,
                              validationErrors: this.state.validationErrors,
                              disabledInput: field.disabled || disabledFields[field.name],
                              visible: fieldVisibility[field.name],
                              fuelCardsLimit:
                                field.fuelCardsLimit > 0 && !appliedInternalSource
                                  ? field.fuelCardsLimit
                                  : maxFuelCards,
                              class: field.class,
                              fieldsToListen: field.fieldsToListen,
                              value: data[field.name],
                              order: currentOrder,
                              externalDataDict,
                              lang,
                              label:
                                `${
                                  field.required &&
                                  (!data[field.name] || (field.type === 'checkBox' && data[field.name] === 'false'))
                                    ? '*'
                                    : ''
                                }` + (field.tr && field.tr[lang] ? field.tr[lang] : field.label),
                              translatedTooltip: field.tooltip[lang] ?? '',
                              currentSection,
                              submitFired,
                              formReadOnly,
                              selectedCompnyId: selectedCompany?.companyId,
                              selectedCostCenterId: selectedCostCenter?.costCenterId,
                              customerManagers: this.state.customerManagers,
                              customerAddresses: this.state.customerAddresses,
                              activeOnly: true,
                              changeTrigger,
                              prefillManagerContacts,
                              removeCompanyAddress,
                              handleChange: (name, e, tooBig, special) =>
                                this.handleChangeInput(name, e, tooBig, special),
                              searchStringDeleted,
                              locationsPrefill: (zipCode: string, location: string) =>
                                this.locationsPrefill(zipCode, location),
                            }}
                          />
                        )
                    )}
                    {currentSection === 'customer' && (
                      <>
                        <div
                          className={`form-element active required ${
                            this.state.requiredField &&
                            !this.state.selectedCompany?.companyName &&
                            'required-field-empty'
                          } ${this.state.selectedCompany?.companyName ? 'required-field-filled' : ''}`}
                        >
                          {visibleWhen(customerSectionFields[customerSectionFieldKeys.company]?.visibleWhen, data) && (
                            <div className="formGroup">
                              <label>
                                {selectedCompany?.companyName ? '' : '*'}
                                {this.getSectionFieldLabel(customerSectionFields[customerSectionFieldKeys.company]) ||
                                  t('COMPANY_NAME')}
                              </label>
                              <div className="companySeactAndSelect" ref={this.customerSearchRef}>
                                <input
                                  style={
                                    this.state.requiredField && !currentOrder.company
                                      ? { border: '2px solid red' }
                                      : undefined
                                  }
                                  type="text"
                                  name={`fieldNameUnique${new Date().getTime()}`}
                                  placeholder={t('PLEASE_SELECT_A_COMPANY')}
                                  value={this.state.companySearchString || selectedCompany.companyName}
                                  onChange={(e) => this.companySearchHandle(e)}
                                  disabled={
                                    this.state.formReadOnly ||
                                    customerSectionFields[customerSectionFieldKeys.company]?.disabled ||
                                    !enabledWhen(
                                      customerSectionFields[customerSectionFieldKeys.company]?.enabledWhen,
                                      data
                                    )
                                  }
                                />
                                {!selectedCompany.companyId && (
                                  <i className={`icon-${this.state.customersListDispaly ? 'up' : 'bottom'}`} />
                                )}
                                {!!selectedCompany.companyId &&
                                  !(
                                    this.state.formReadOnly ||
                                    customerSectionFields[customerSectionFieldKeys.company]?.disabled ||
                                    !enabledWhen(
                                      customerSectionFields[customerSectionFieldKeys.company]?.enabledWhen,
                                      data
                                    )
                                  ) && <i onClick={() => this.clearCompany()} className="icon-clear" />}
                                {Arr.any(filteredCustomers) &&
                                  this.state.customersListDispaly &&
                                  !selectedCompany.companyId && (
                                    <div className="cantonsOptionArea">
                                      {customersToDisplay.map((el) => (
                                        <div className="cantonsOption" onClick={() => this.selectedCompany(el)}>
                                          {el?.name}
                                        </div>
                                      ))}
                                      {filteredCustomers.length > customersToDisplay.length &&
                                        !this.state.companySearchString && (
                                          <div style={{ backgroundColor: 'gray' }} className="cantonsOption">
                                            {t('MORE_COMPANIES_AVAILABLE')}
                                          </div>
                                        )}
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                          <p />
                        </div>
                        <div
                          className={`form-element active required ${
                            this.state.requiredField &&
                            !noCostCentersForCompany &&
                            !this.state.selectedCostCenter?.costCenterName &&
                            'required-field-empty'
                          } ${this.state.selectedCostCenter?.costCenterName ? 'required-field-filled' : ''}`}
                        >
                          {visibleWhen(customerSectionFields[customerSectionFieldKeys.unit]?.visibleWhen, data) && (
                            <div className="formGroup">
                              <label>
                                {' '}
                                {selectedCostCenter?.costCenterId ? '' : '*'}
                                {this.getSectionFieldLabel(customerSectionFields[customerSectionFieldKeys.unit]) ||
                                  t('COST_CENTER')}
                              </label>
                              <div className={'selectArea selectfuelCard'}>
                                <select
                                  onChange={(e) => this.selectedCostCenter(e)}
                                  defaultValue={
                                    formReadOnly
                                      ? currentOrder?.costCenter?.costCenterName
                                      : selectedCostCenter
                                      ? selectedCostCenter?.costCenterId
                                      : ''
                                  }
                                  disabled={
                                    this.state.formReadOnly ||
                                    customerSectionFields[customerSectionFieldKeys.unit]?.disabled ||
                                    !enabledWhen(
                                      customerSectionFields[customerSectionFieldKeys.unit]?.enabledWhen,
                                      data
                                    )
                                  }
                                  className="required-highlight"
                                >
                                  <option selected={!selectedCostCenter?.costCenterId} disabled={true} value="">
                                    {costCenterList.length > 0
                                      ? t('PLEASE_SELECT_A_VALUE')
                                      : noCostCentersForCompany
                                      ? t('NO_COST_CENTER_AVAILABLE')
                                      : t('PLEASE_SELECT_A_VALUE')}
                                  </option>
                                  {!formReadOnly ? (
                                    !!this.state?.currentOrder?.approvalProcessId &&
                                    selectedCostCenter &&
                                    filteredCustomers.length > 0 ? (
                                      costCenterList.map((obj) => (
                                        <option value={obj.id} selected={obj.id === selectedCostCenter?.costCenterId}>
                                          {obj.name || t('NO_COST_CENTER')}
                                        </option>
                                      ))
                                    ) : (
                                      costCenterList.map((obj) => (
                                        <option value={obj.id}>{obj.name || t('NO_COST_CENTER')}</option>
                                      ))
                                    )
                                  ) : (
                                    <option key={currentOrder?.costCenter?.costCenterId} selected={true}>
                                      {currentOrder?.costCenter?.costCenterName}
                                    </option>
                                  )}
                                </select>
                                <i className="icon-bottom" />
                              </div>
                            </div>
                          )}
                          <p />
                        </div>
                        <div className="form-element active optional">
                          {visibleWhen(customerSectionFields[customerSectionFieldKeys.user]?.visibleWhen, data) && (
                            <div className="formGroup">
                              <label>
                                {this.getSectionFieldLabel(customerSectionFields[customerSectionFieldKeys.user]) ||
                                  t('USER')}
                              </label>
                              <input
                                style={
                                  this.state.requiredField && !currentOrder?.userDisplayName
                                    ? { border: '2px solid red' }
                                    : undefined
                                }
                                type="text"
                                name={`fieldnameveryunique${new Date().getTime()}`}
                                autoComplete="none"
                                list="autocompleteOff"
                                value={currentUser}
                                onChange={(e) => this.userChangeHandle(e)}
                                disabled={
                                  this.state.formReadOnly ||
                                  customerSectionFields[customerSectionFieldKeys.user]?.disabled ||
                                  !enabledWhen(customerSectionFields[customerSectionFieldKeys.user]?.enabledWhen, data)
                                }
                              />
                            </div>
                          )}
                          <p />
                        </div>
                        {customerSectionFormFields.map(
                          (field, i) =>
                            !field.isHiddenOnForm && (
                              <Element
                                key={i}
                                field={{
                                  ...field,
                                  index: i + formFields.length,
                                  lang: i18n.language,
                                  data,
                                  validationErrors: this.state.validationErrors,
                                  minimumValue: field.minimumValue,
                                  maximumValue: field.maximumValue,
                                  step: field.step,
                                  disabledInput: field.disabled || disabledFields[field.name],
                                  defaultValue: field.defaultValue,
                                  visible: fieldVisibility[field.name],
                                  fuelCardsLimit: field.fuelCardsLimit,
                                  class: field.class,
                                  fieldsToListen: field.fieldsToListen,
                                  value: data[field.name],
                                  order: currentOrder,
                                  internalSource: field.internalSource,
                                  customerManagers: this.state.customerManagers,
                                  customerAddresses: this.state.customerAddresses,
                                  externalDataDict,
                                  translatedTooltip: field.tooltip[lang] ?? '',
                                  label: field.tr[lang] || field.label,
                                  currentSection,
                                  submitFired,
                                  formReadOnly,
                                  selectedCompnyId: selectedCompany?.companyId,
                                  selectedCostCenterId: selectedCostCenter?.costCenterId,
                                  activeOnly: true,
                                  changeTrigger,
                                  prefillManagerContacts,
                                  removeCompanyAddress,
                                  handleChange: (name, e, tooBig, special) =>
                                    this.handleChangeInput(name, e, tooBig, special),
                                  searchStringDeleted,
                                }}
                              />
                            )
                        )}
                      </>
                    )}
                    {currentSection === 'approve' && (
                      <div className="approveArea">
                        <div className="selectArea">
                          <select
                            value={currentApprovalWorflowConfigId}
                            onChange={(e) => this.handleApprovalProcessConfigChage(e)}
                            disabled={
                              formReadOnly ||
                              (currentOrder && !!currentOrder?.approvalProcess?.id) ||
                              availableApprovalProcessesToUse.length === 1
                            }
                          >
                            {approvalProcessesForDropDown.map((ac) => (
                              <option value={ac.id}>{`${ac.tr?.[this.props.i18n.language] || t(ac.name)} `}</option>
                            ))}
                          </select>
                          <i className="icon-bottom" />
                        </div>
                        {canAppove &&
                          !!currentOrder?.approvalProcess?.id &&
                          !user?.isAdmin &&
                          !this.state.approveConfirmed && (
                            <>
                              {this.state.approversLoading ? (
                                <div>
                                  {' '}
                                  <LoadingSpinner />{' '}
                                </div>
                              ) : (
                                currentOrder &&
                                currentOrder.approvalProcess &&
                                currentOrder.approvalProcess.status === 'Pending' && (
                                  <>
                                    <div>
                                      <label> {t('APPROVAL/DENIAL_NOTE')}: </label>
                                      <textarea
                                        className={`approval-note ${showDeclineReasonValidation ? 'invalid' : 'valid'}`}
                                        placeholder={t('FILL_NOTE_FIELD')}
                                        onChange={(e) => this.saveNoteValue(e)}
                                        value={this.state.noteValueToPost}
                                      />
                                    </div>
                                    <div className="buttonAreaSmall">
                                      <button
                                        disabled={loading || this.state.approversLoading}
                                        className="red"
                                        onClick={() => this.sendDecline()}
                                      >
                                        <i className="icon-denied" />
                                        <span>{t('DECLINE')}</span>
                                      </button>
                                      <button
                                        disabled={loading || this.state.approversLoading}
                                        className="green"
                                        onClick={() => this.showConfirm()}
                                      >
                                        <i className="icon-check" />
                                        <span>
                                          {t('APPROVE_STEP')}
                                          {currentOrder.approvalProcess?.steps &&
                                            currentOrder.approvalProcess.steps.filter((obj) => obj.status !== 'Pending')
                                              .length + 1}
                                        </span>
                                      </button>
                                    </div>
                                  </>
                                )
                              )}
                            </>
                          )}
                        <div>{!!ordersSteps?.length && <ApprovalProcessSteps steps={ordersSteps} />}</div>
                        <div>
                          {!!currentApprovalProcessConfig && !!user?.isInternalUser && !match?.params?.orderId && (
                            <ApprovalProcessConfigSteps
                              approvalProcessConfig={currentApprovalProcessConfig}
                              formId={currentForm.id}
                            />
                          )}
                        </div>
                        <div className="bottom-section">
                          {!!currentOrder?.id && (
                            <label className="idLabel" onClick={() => this.copyId(currentOrder?.id)}>
                              {t('ID')}: {currentOrder?.id}
                            </label>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {!this.props.formConfigurating && !mobileVersion && (
                    <div className="btnArea">
                      <a
                        onClick={() => this.props.history.push(mobileVersion ? '/' : requestsPageUrl)}
                        className="btn btnClose"
                      >
                        <i className="icon-close"></i> <span>{t('CLOSE')}</span>
                      </a>
                      {!formReadOnly &&
                        (!!user?.tenant || currentForm.allowedForInternalUsers) &&
                        (!currentOrder?.approvalProcessId || currentOrder?.approvalProcessId === emptyGuid) && (
                          <>
                            <a className="btn btnSave" type="submit" onClick={(e) => this.handleSubmit(e)}>
                              <i className="icon-save"></i>
                              <span className="tooltip">{t('SAVE_DRAFT')}</span>
                            </a>
                            <a
                              className="btn btnOk"
                              type="submit"
                              onClick={(e) => this.handleSubmit(e, true)}
                              style={{
                                pointerEvents: loading || this.state.approversLoading ? 'none' : 'auto',
                              }}
                            >
                              <i className="icon-check"></i>
                              <span className="tooltip">{t('SUBMIT')}</span>
                            </a>
                          </>
                        )}
                      {user?.isInternalUser && !!currentOrder?.id && (
                        <>
                          {!currentOrder?.archived && !!currentOrder?.approvalProcess?.status && (
                            <a onClick={() => this.archiveOrRestoreOrder(currentOrder.id)} className="btn archive">
                              <i className="icon-archive2"></i> <span>{t('ARCHIVE_ORDER')}</span>
                            </a>
                          )}
                          {currentOrder?.archived && (
                            <a
                              onClick={() => this.archiveOrRestoreOrder(currentOrder.id, true)}
                              className="btn restore-from-archive"
                            >
                              <i className="icon-unarchive"></i> <span>{t('RESTORE_ORDER_FROM_ARCHIVE')}</span>
                            </a>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
                <ul className={mobileVersion ? 'ordersLabelsMobile' : 'ordersLabels'}>
                  {!mobileVersion && (
                    <li
                      className={
                        currentOrder && currentOrder?.approvalProcess
                          ? currentOrder?.approvalProcess.status + ' statusLabel'
                          : 'draft statusLabel'
                      }
                    >
                      <span className="btnReq">
                        <a className="btn printButton" onClick={() => this.exportToPDF()}>
                          <i className="icon-pdf" />
                        </a>
                        <a className="btn printButton" id="clickPrint" onClick={() => this.previewOrPrint()}>
                          <i className="icon-print" />
                        </a>
                        {!!this.props.user?.isInternalUser && (
                          <a className="btn dcsButton" id="dcsView" onClick={() => this.dcsView()}>
                            <i className="icon-focus" />
                          </a>
                        )}
                      </span>
                      <span>
                        {currentOrder?.approvalProcess
                          ? currentOrder.approvalProcess.status &&
                            currentForm?.approvalProcessConfigs.at(0)?.steps?.at(0)?.autoApprove
                            ? t('SENT')
                            : t(currentOrder.approvalProcess.status?.toUpperCase() ?? '')
                          : t('DRAFT')}
                      </span>
                    </li>
                  )}
                  <li
                    style={{ zIndex: 99996 }}
                    onClick={() => this.sectionHandle('customer')}
                    className={this.state.currentSection === 'customer' ? 'selected' : undefined}
                  >
                    <i className="icon-customers" />
                    <span
                      style={
                        this.state.submitFired &&
                        (!this.state.selectedCompany?.companyId || !this.state.selectedCostCenter?.costCenterId)
                          ? { color: 'red', fontWeight: 'bolder' }
                          : undefined
                      }
                      className="labelTitle"
                    >
                      {customerSection?.tr?.[this.props.i18n.language] || t('CUSTOMER')}
                    </span>
                  </li>
                  {currentForm?.sections?.slice(1).map((s, i) => (
                    <li
                      key={i}
                      onClick={() => this.sectionHandle(s.name)}
                      className={this.state.currentSection === s.name ? 'selected' : undefined}
                      style={{ zIndex: 99 - i }}
                    >
                      <i className={s.icon} />
                      <span
                        className="labelTitle"
                        style={
                          this.state.sectionsDict && this.state.sectionsDict[s.name] === true
                            ? { color: 'red', fontWeight: 'bolder' }
                            : undefined
                        }
                      >
                        {s.tr?.[lang] || s.name}
                      </span>
                    </li>
                  ))}
                  {!firstStepAutoApprove && (
                    <li
                      onClick={() => this.sectionHandle('approve')}
                      className={this.state.currentSection === 'approve' ? 'selected' : undefined}
                    >
                      <i className="icon-sign" />
                      <span className="labelTitle">{t('APPROVE/SIGN')}</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <Confirm
              visible={this.state.showDeclineConfirm}
              onClose={(confirm: boolean) => {
                this.handleDeclineClose(confirm)
              }}
              title={t('PLEASE_CONFIRM')}
              message={`${t('DO_YOU_WANT_TO_DECLINE_STEP')} ${
                currentOrder.approvalProcess?.steps &&
                currentOrder.approvalProcess.steps.filter((obj) => obj.status !== 'Pending').length + 1
              }?`}
            />
            <Confirm
              visible={this.state.showApproveConfirm}
              onClose={(confirm: boolean) => {
                this.handleConfirmClose(confirm)
              }}
              title={t('PLEASE_CONFIRM')}
              message={`${t('DO_YOU_WANT_TO_APPROVE_STEP')} ${
                currentOrder.approvalProcess?.steps &&
                currentOrder.approvalProcess.steps.filter((obj) => obj.status !== 'Pending').length + 1
              }?`}
            />
            <Alert
              onClose={() => {
                this.closeApprovedRequest()
              }}
              visible={nothingToApprove.visible}
              title={nothingToApprove.title}
              message={nothingToApprove.message}
            />
            <Alert
              onClose={() => {
                this.closeUpdatedStep()
              }}
              visible={alreadyUpdatedStepAlert.visible}
              title={alreadyUpdatedStepAlert.title}
              message={alreadyUpdatedStepAlert.message}
            />
            <Alert
              onClose={() => {
                this.closeDeletedAlert()
              }}
              visible={requestWasDeletedAlert.visible}
              title={requestWasDeletedAlert.title}
              message={requestWasDeletedAlert.message}
            />
            <Alert
              onClose={() => {
                this.toggleAlert()
              }}
              visible={deleteAlertState.visible}
              title={deleteAlertState.title}
              message={deleteAlertState.message}
            />
            <Alert
              onClose={() => {
                this.toggleAlert2()
              }}
              visible={reasonRequiredAlertState.visible}
              title={reasonRequiredAlertState.title}
              message={reasonRequiredAlertState.message}
            />
            <Alert
              onClose={() => {
                this.toggleAlert3()
              }}
              visible={approvalStepFailAlertState.visible}
              title={approvalStepFailAlertState.title}
              message={approvalStepFailAlertState.message}
            />

            {/* Here starts the DCS view 'component' */}
            {/*    ||          */}
            {/*    ||          */}
            {/*    \/          */}
            <div
              className="dcsView tableParent"
              style={this.state.dcsMode && !loading ? { display: 'unset' } : { display: 'none' }}
            >
              {window.location.pathname.indexOf('/view=dcs') > -1 && (
                <div className="itemTitle">
                  {getFormTitle(currentForm, lang, true)}
                  <div className="rightTools">
                    <Slider
                      label={t('EMPTY_FIELDS')}
                      labelPosition={'before'}
                      checked={orderDetailsSettings.showEmptyFields}
                      onChange={() => this.toggleShowEmptyFields()}
                    ></Slider>
                    <a className="btn printButton" id="clickPrint" onClick={() => this.previewOrPrint()}>
                      <i className="icon-print" />
                    </a>
                    <button onClick={() => this.backToOrderFromDCS()}>
                      <i className="icon-left" /> {t('BACK')}
                    </button>
                  </div>
                </div>
              )}

              <table id="tableToPrint" className="tableChild">
                <tbody>
                  <tr>
                    <td className="titleTd" colSpan={6}>
                      <i className="icon-customers" /> <span>{t('CUSTOMER')}</span>
                      <i
                        onClick={() => this.changeSectionsView('customer')}
                        className={this.state.sectionsToShowInDCS.includes('customer') ? 'icon-bottom' : 'icon-up'}
                      />
                    </td>
                  </tr>
                  {this.state.sectionsToShowInDCS.includes('customer') && (
                    <>
                      <tr className={!selectedCompany?.companyName ? 'disabled' : ''}>
                        <td>{t('COMPANY_NAME')}</td>
                        <td onClick={() => this.copyId(selectedCompany?.companyName, true)} colSpan={5}>
                          {selectedCompany?.companyName}
                          {selectedCompany?.companyName && <i className="icon-copy" />}
                        </td>
                      </tr>
                      <tr className={!selectedCostCenter?.costCenterName ? 'disabled' : ''}>
                        <td>{t('COST_CENTER')}</td>
                        <td onClick={() => this.copyId(selectedCostCenter?.costCenterName, true)} colSpan={5}>
                          {selectedCostCenter?.costCenterName}
                          {selectedCostCenter?.costCenterName && <i className="icon-copy" />}
                        </td>
                      </tr>
                      <tr className={!currentUser ? 'disabled' : ''}>
                        <td>{t('USER')}</td>
                        <td onClick={() => this.copyId(currentUser, true)} colSpan={5}>
                          {currentUser}
                          {currentUser && <i className="icon-copy" />}
                        </td>
                      </tr>
                    </>
                  )}
                  {currentForm?.sections?.map((obj, index) => {
                    if (index === 0) {
                      return
                    }
                    if (data[PL001] === 'rad1' && index === 2) {
                      return
                    } else {
                      return (
                        <>
                          <tr>
                            <td className="titleTd" colSpan={6}>
                              <i className={obj.icon} /> <span>{obj.tr?.[lang] || obj.name}</span>
                              <i
                                onClick={() => this.changeSectionsView(obj.name)}
                                className={
                                  this.state.sectionsToShowInDCS.includes(obj.name) ? 'icon-bottom' : 'icon-up'
                                }
                              />
                            </td>
                          </tr>
                          {this.state.sectionsToShowInDCS.includes(obj.name) &&
                            currentForm?.formFields.map(
                              (field, i) =>
                                field.section === obj.name &&
                                (orderDetailsSettings.showEmptyFields || this.getFieldValue(field, data, lang)) &&
                                field.type.toLowerCase() !== 'separator' &&
                                !field.isHiddenOnDcs && (
                                  <tr key={i} className={!this.getFieldValue(field, data, lang) ? 'disabled' : ''}>
                                    <td>{field.tr[lang] || field.label}</td>
                                    <td
                                      onClick={() =>
                                        !data[field.name]
                                          ? null
                                          : this.copyId(this.getFieldValue(field, data, lang), true)
                                      }
                                      colSpan={5}
                                    >
                                      {this.getFieldValue(field, data, lang)}
                                      {!!this.getFieldValue(field, data, lang) && <i className="icon-copy" />}
                                    </td>
                                  </tr>
                                )
                            )}
                        </>
                      )
                    }
                  })}
                  <tr>
                    <td className="titleTd" colSpan={6}>
                      <i className="icon-sign" /> <span>{t('APPROVE/SIGN')}</span>
                      <i
                        onClick={() => this.changeSectionsView('approve')}
                        className={this.state.sectionsToShowInDCS.includes('approve') ? 'icon-bottom' : 'icon-up'}
                      />{' '}
                    </td>
                  </tr>
                  {this.state.sectionsToShowInDCS.includes('approve') && (
                    <>
                      <tr>
                        <td>{t('ID')}</td>
                        <td onClick={() => this.copyId(currentOrder?.id)} colSpan={5}>
                          {currentOrder?.id}
                          {currentOrder?.id && <i className="icon-copy" />}
                        </td>
                      </tr>
                      <tr>
                        <td>{t('STATUS')}</td>
                        <td colSpan={5}>
                          {currentOrder && currentOrder?.approvalProcess
                            ? t(currentOrder.approvalProcess?.status?.toUpperCase() ?? '')
                            : t('DRAFT')}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
                <tbody className="apprTab">
                  <tr>
                    <th>{t('STEP')}</th>
                    <th>{t('USER_NAME')}</th>
                    <th>{t('DATE')}</th>
                    <th>{t('NOTE')}</th>
                  </tr>
                  {ordersSteps?.map(
                    (row, index) =>
                      row.status !== approvalStepsStatuses.pending && (
                        <tr key={index}>
                          <td className="ApproveStep" key={row.step}>
                            {row.step}
                          </td>
                          <td className="ApproveUser" key={row.userDisplayName}>
                            <span className="textEllipsis">{row.userDisplayName}</span>
                            <i
                              className="icon-copy"
                              style={{ cursor: 'pointer' }}
                              onClick={() => this.copyId(row.userDisplayName, true)}
                            />
                          </td>
                          <td className="ApproveDate" key={printDate(row.timestamp)}>
                            {printDate(row.timestamp, true)}
                          </td>
                          <td className="ApproveNote tooltip">
                            {Object.keys(row.notes).length > 0 ? (
                              <>
                                <div className="textEllipsis">
                                  {Object.keys(row.notes)
                                    .map((k) => row.notes[k])
                                    .join('; ')}
                                </div>
                              </>
                            ) : null}
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
            {/*   /\    */}
            {/*   ||    */}
            {/*   ||    */}
            {/* That's where DCS component ends */}
            <div
              className="tableParent"
              style={this.state.htmlMode && !loading ? { display: 'unset' } : { display: 'none' }}
            >
              {window.location.pathname.indexOf('/view=html') === -1 && (
                <div className="backToFormHeader">
                  <button onClick={() => this.backToForm()}>{t('BACK_TO_FORM')}</button>
                </div>
              )}
              <table id="tableToPrint" className="tableChild">
                <caption>
                  <img
                    src="/interfleet4u-new2.svg"
                    className="logoTable"
                    width="200"
                    height="56"
                    alt="Interfleet4U | Auto-Interleasing Fleet Management System"
                  />
                  <span>{getFormTitle(currentForm, lang, true)}</span>
                </caption>
                <tbody>
                  <tr>
                    <td className="titleTd" colSpan={6}>
                      {t('CUSTOMER')}
                    </td>
                  </tr>
                  <tr>
                    <td>{t('COMPANY_NAME')}</td>
                    <td colSpan={5}>{selectedCompany?.companyName}</td>
                  </tr>
                  <tr>
                    <td>{t('COST_CENTER')}</td>
                    <td colSpan={5}>{selectedCostCenter?.costCenterName}</td>
                  </tr>
                  <tr>
                    <td>{t('USER')}</td>
                    <td colSpan={5}>{currentUser}</td>
                  </tr>
                  {currentForm?.sections?.map((obj, index) => {
                    if (index === 0) {
                      return
                    }
                    if (data[PL001] === 'rad1' && index === 2) {
                      return
                    } else {
                      return (
                        <>
                          <tr>
                            <td className="titleTd" colSpan={6}>
                              {obj.tr?.[lang] || obj.name}
                            </td>
                          </tr>
                          {fieldsWithAppliedInternalSource?.map(
                            (field, i) =>
                              field.section === obj.name &&
                              field.type.toLowerCase() !== 'separator' &&
                              !field.isHiddenOnPrint && (
                                <tr key={i}>
                                  <td>{field.tr ? field.tr[lang] : field.label}</td>
                                  <td colSpan={5}>{this.getFieldValue(field, data, lang)}</td>
                                </tr>
                              )
                          )}
                        </>
                      )
                    }
                  })}
                  <tr>
                    <td className="titleTd" colSpan={6}>
                      {t('APPROVE/SIGN')}
                    </td>
                  </tr>
                  <tr>
                    <td>{t('ID')}</td>
                    <td colSpan={5}>{currentOrder?.id}</td>
                  </tr>
                  <tr>
                    <td>{t('STATUS')}</td>
                    <td colSpan={5}>
                      {currentOrder && currentOrder?.approvalProcess
                        ? t(currentOrder.approvalProcess?.status?.toUpperCase() ?? '')
                        : t('DRAFT')}
                    </td>
                  </tr>
                </tbody>
                <tbody className="apprTab">
                  <tr>
                    <th>{t('STEP')}</th>
                    <th>{t('USER_NAME')}</th>
                    <th>{t('DATE')}</th>
                    <th>{t('NOTE')}</th>
                  </tr>
                  {ordersSteps?.map(
                    (row, index) =>
                      row.status !== approvalStepsStatuses.pending && (
                        <tr key={index}>
                          <td className="ApproveStep" key={row.step}>
                            {row.step}
                          </td>
                          <td className="ApproveUser" key={row.userDisplayName}>
                            <span className="textEllipsis">{row.userDisplayName}</span>
                          </td>
                          <td className="ApproveDate" key={printDate(row.timestamp)}>
                            {printDate(row.timestamp, true)}
                          </td>
                          <td className="ApproveNote tooltip">
                            {Object.keys(row.notes).length > 0 ? (
                              <>
                                <div className="textEllipsis">
                                  {Object.keys(row.notes)
                                    .map((k) => row.notes[k])
                                    .join('; ')}
                                </div>
                              </>
                            ) : null}
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <>
            <Alert
              onClose={() => {
                this.closeDeletedAlert()
              }}
              visible={requestWasDeletedAlert.visible}
              title={requestWasDeletedAlert.title}
              message={requestWasDeletedAlert.message}
            />
            <div className="loadingRequest">
              <span>{t('LOADING')}</span>
            </div>
          </>
        )}
        {this.state.copiedPopUpToggle && <IdIsCopied value={this.state.isValue} idCopied={this.state.idCopied} />}
      </Loader>
    )
  }

  private getFieldValue(
    field: OrdersFormFieldViewModel,
    data: Partial<Record<string, string>>,
    lang: string
  ): string | undefined {
    const { currentOrder } = this.state
    let valid = true
    const fieldValue = data[field.name]
    if (field.visibleWhen) {
      Object.keys(field.visibleWhen).forEach((fieldName) => {
        const val = data[fieldName]
        if (val) {
          if (!field.visibleWhen[fieldName].includes(val)) {
            valid = false
          }
        } else {
          valid = false
        }
      })
    }

    if (!valid) {
      return undefined
    }

    switch (field.type) {
      case 'radio': {
        const found = field.options.find((option) => option.value === data[field.name])
        return found?.tr?.[lang] ? found.tr[lang] : found?.name
      }
      case 'checkBox':
        return data[field.name] === 'true' ? this.props.t('YES') : this.props.t('NO')
      case 'customersSelect':
        return fieldValue ? this.getCustomerNameById(fieldValue) : fieldValue
      case 'customersSelectUnlinked':
        return fieldValue ? this.getCustomerNameById(fieldValue) : fieldValue
      case 'unitsSelect':
        return fieldValue ? this.getUnitNameById(fieldValue) : fieldValue
      case 'unitsSelectUnlinked':
        return fieldValue ? this.getUnitNameById(fieldValue) : fieldValue
      case 'upload':
        return fieldValue?.startsWith('$doc:')
          ? currentOrder.documents.find((d) => fieldValue.endsWith(d.id))?.fileName
          : fieldValue?.split('|').at(0)
      default:
        return fieldValue?.split(';base64')[0].split('|')[0]
    }
  }

  private getCustomerNameById(id: string) {
    return this.state.companyDict[id]?.name || id
  }

  private getUnitNameById(id: string): string {
    const { t } = this.props

    return this.state.costCenterDict[id]?.name || (id ? t('NO_COST_CENTER') : '')
  }

  private changeSectionsView(section: string) {
    let sections = ObjectHelper.clone(this.state.sectionsToShowInDCS)
    if (!sections.includes(section)) {
      sections.push(section)
    } else {
      sections = sections.filter((el) => el !== section)
    }
    this.setState({
      sectionsToShowInDCS: sections,
    })
  }

  private dcsView() {
    const { history } = this.props
    if (window.location.pathname.indexOf(`/${this.props.match.params.formId}`) > -1) {
      history.push(`${window.location.pathname}/view=dcs`)
      this.setState({
        dcsMode: true,
      })
    } else {
      history.push(`${window.location.pathname}/view=dcs`)
      this.setState({
        dcsMode: true,
      })
    }
  }

  private copyId(e?: string, value?: boolean) {
    if (!e) {
      return
    }

    navigator.clipboard.writeText(e)

    if (value) {
      this.setState({
        isValue: value,
      })
    }
    this.setState({
      idCopied: true,
      copiedPopUpToggle: true,
    })
  }

  private filterUnitsByUnlinkedCustomerId(customerId: string) {
    const { externalDataDict } = this.state
    const { t } = this.props

    const timeStamp = new Date().getTime()

    const data: { [id: string]: string } = {}

    const costCenterList = this.getCostCentersByCompany(customerId)

    costCenterList.forEach((cc) => {
      data[cc.id] = cc.name || t('NO_COST_CENTER')
    })

    const unitsSelectUnlinked: IExternalDataItem = {
      timeStamp,
      data,
    }

    this.setState((prev) => ({
      externalDataDict: { ...prev.externalDataDict, unitsSelectUnlinked },
    }))
  }

  private updateFilteredCustomers() {
    const { user, customers } = this.props
    const { currentForm, filterCompamniesByMatchingApprovalFlows, validCompaniesForApprovalFlows, externalDataDict } =
      this.state

    const timeStamp = new Date().getTime()

    const allowedCustomerState = ['ActiveFleet', 'DiscontinuedFleet', 'Lost', 'NoGwg']

    let filteredCustomers = !user?.isInternalUser
      ? customers
      : currentForm.ownerTenant
      ? customers.filter((c) => c.tenantId === currentForm.ownerTenant)
      : []

    filteredCustomers = filteredCustomers.toSorted((a, b) => a.name.localeCompare(b.name))

    const filteredCustomersDict: { [id: string]: string } = {}

    const companyDict: { [id: string]: CustomerViewModel } = {}
    const costCenterDict: { [id: string]: UnitAccountViewModel } = {}
    filteredCustomers.forEach((c) => {
      filteredCustomersDict[c.id] = c.name
      companyDict[c.id] = c
      c.units?.forEach((u) => {
        costCenterDict[u.id] = u
      })
    })

    const filteredCustomersForDataDict: IExternalDataItem = {
      timeStamp,
      data: filteredCustomersDict,
    }

    this.setState((prev) => ({
      filteredCustomers: filteredCustomers.filter((c) => {
        return (
          (filterCompamniesByMatchingApprovalFlows ? validCompaniesForApprovalFlows[c.id] : true) &&
          c.state &&
          allowedCustomerState.includes(c.state)
        )
      }),
      externalDataDict: {
        ...prev.externalDataDict,
        customersSelect: filteredCustomersForDataDict,
        customersSelectUnlinked: filteredCustomersForDataDict,
      },
      companyDict,
      costCenterDict,
    }))
  }

  private clearCompany() {
    this.setState({
      selectedCompany: {
        companyId: '',
        companyName: '',
      },
      companySearchString: '',
    })
    this.prefillManagerContacts()
    this.removeCompanyAddress()
  }

  private updateAvailableApprovalProcessesFromAdvancedConfig() {
    const { currentForm, availableApprovalProcesses, data } = this.state
    const newData = { ...data }
    const costCenterId = 'costCenterId'
    const companyId = 'companyId'
    newData[costCenterId] = this.state.selectedCostCenter?.costCenterId
    newData[companyId] = this.state.selectedCompany?.companyId
    const advancedApprovalProcessConfigs = currentForm?.approvalWorkflowsAdv

    const availableApprovalProcessesAdv: ApprovalProcessConfigViewModel[] = []

    if (!!advancedApprovalProcessConfigs && Object.keys(advancedApprovalProcessConfigs).length > 0) {
      Object.keys(advancedApprovalProcessConfigs).forEach((approvalProcessId) => {
        const matchingCompanyApprovalProcess = availableApprovalProcesses.find((vapp) => vapp.id === approvalProcessId)

        if (matchingCompanyApprovalProcess) {
          const approvalProcessConditions = advancedApprovalProcessConfigs[approvalProcessId]
          const conditionsFields = Object.keys(approvalProcessConditions)

          const fieldMatch = conditionsFields.map((field) =>
            approvalProcessConditions[field][0][0] === '!'
              ? approvalProcessConditions[field].filter((el) => el === `!${newData[field]}`).length === 0
              : approvalProcessConditions[field].filter((el) => el === newData[field])?.length > 0
          )
          fieldMatch.push(true)

          if (fieldMatch.reduce((prev, next) => prev && next, true)) {
            availableApprovalProcessesAdv.push(matchingCompanyApprovalProcess)
          }
        }
      })
    }
    this.setState({
      availableApprovalProcessesAdv,
    })
  }

  private archiveOrRestoreOrder(orderId: string, restore?: boolean) {
    this.setState({
      loading: true,
    })

    const promise = restore ? this.props.restoreOrderFromArchive(orderId) : this.props.archiveOrder(orderId)
    promise.then(
      () => {
        this.setState({
          loading: false,
        })

        this.props.history.push(requestsPageUrl)
      },
      () => {
        this.setState({
          loading: false,
        })
      }
    )
  }

  private toggleShowEmptyFields() {
    const updatedSettings = {
      showEmptyFields: !this.state.orderDetailsSettings.showEmptyFields,
    }
    this.setState({
      orderDetailsSettings: updatedSettings,
    })
    FrontendSettings.set(FrontendSettingsKeys.orderDetails, JSON.stringify(updatedSettings))
  }

  private handleDeclineClose(confirm: boolean) {
    const { currentOrder } = this.state
    if (!currentOrder?.approvalProcessId) return

    const nextPendingStep = currentOrder.approvalProcess?.steps
      ?.toSorted((a, b) => a.step - b.step)
      ?.filter((s) => s.status === approvalStepsStatuses.pending)[0]?.step
    const data: NextApprovalStepInputModel = {
      decline: true,
      note: this.state.noteValueToPost,
      step: nextPendingStep || 0,
    }
    if (confirm) {
      this.setState({ loading: true, approversLoading: true })
      this.props.postNextApprovalProcessStep(currentOrder.approvalProcessId, data).then(
        (approvalProcess) => {
          this.setState({ loading: false, approversLoading: false, approvalProcess })
          this.props.history.push(requestsPageUrl)
        },
        () => {
          this.handleFailedApprovalStep()
        }
      )
    }
    this.setState({
      showDeclineConfirm: false,
    })
  }

  private handleFailedApprovalStep() {
    this.setState({
      loading: false,
      approversLoading: false,
      approvalStepFailAlertState: {
        title: this.props.t('WARNING'),
        message: this.props.t('REQUEST_STEP_FAILED_MESSAGE'),
        visible: true,
      },
    })
  }

  private handleReturnOrderConflict() {
    this.setState({
      loading: false,
      approversLoading: false,
      approvalStepFailAlertState: {
        title: this.props.t('WARNING'),
        message: this.props.t('RETURN_ORDER_CONFLICT'),
        visible: true,
      },
    })
  }

  private updateVisibility(oldData?: Partial<Record<string, string>>) {
    const { fieldVisibility, disabledFields, data, fieldsWithAppliedInternalSource } = this.state
    const newFieldVisibility = { ...fieldVisibility }
    const newDisabledFields = { ...disabledFields }
    const newData = { ...data }
    let changed = 0
    fieldsWithAppliedInternalSource?.forEach((f) => {
      const visible = visibleWhen(f.visibleWhen, data)

      if (fieldVisibility[f.name] !== visible) {
        if (visible) {
          if (f.type === datePickerFieldType && f.defaultValue === datePickerAlwaysTodayWhenEmpty && !newData[f.name]) {
            newData[f.name] = printDate(new Date())
          } else {
            if (!!f.defaultValue && !newData[f.name]) {
              newData[f.name] = f.defaultValue
            }
          }
        }
        newFieldVisibility[f.name] = visible
        changed++
      }

      if (!visible && newData[f.name] !== undefined) {
        delete newData[f.name]
        changed++
      }

      const disabled = !enabledWhen(f.enabledWhen, data)
      if (disabledFields[f.name] !== disabled) {
        if (disabled) {
          newDisabledFields[f.name] = disabled
        } else {
          delete newDisabledFields[f.name]
        }
      }

      if (!!oldData && !!oldData[f.name] && oldData[f.name] !== newData[f.name] && f.clearOnChange?.length > 0) {
        Object.keys(newData)
          .filter((key) => !!newData[key] && f.clearOnChange.includes(key))
          .forEach((key) => {
            changed++
            delete newData[key]
          })
      }
    })
    if (changed > 0) {
      if (!ObjectHelper.areEqual(this.state.fieldVisibility, newFieldVisibility)) {
        this.setState({
          fieldVisibility: newFieldVisibility,
        })
      }
      if (!ObjectHelper.areEqual(this.state.disabledFields, newDisabledFields)) {
        this.setState({
          disabledFields: newDisabledFields,
        })
      }
      if (!ObjectHelper.areEqual(this.state.data, newData)) {
        this.setState({
          data: newData,
        })
      }
    }
  }

  private fillDefaultValues() {
    const { fieldsWithAppliedInternalSource } = this.state
    const data = { ...this.state.data }
    const keys = Object.keys(data)

    fieldsWithAppliedInternalSource?.forEach((f) => {
      if (!!f.defaultValue && !keys.includes(f.name)) {
        if (f.type === datePickerFieldType && f.defaultValue === datePickerAlwaysTodayWhenEmpty) {
          return
        }
        data[f.name] = f.defaultValue
      }
    })

    this.setState({
      data,
    })
  }

  private getSectionFieldLabel(field?: OrdersFormFieldViewModel): string {
    return field?.tr?.[this.props.i18n.language] ?? field?.label ?? ''
  }

  private backToOrderFromDCS() {
    const { history } = this.props
    history.goBack()
  }

  private backToForm() {
    const { history } = this.props
    history.push(`${requestsPageUrl}/new/${this.props.match.params.formId}`)
    this.setState({
      htmlMode: false,
    })
  }

  private previewOrPrint() {
    const { selectedCompany, selectedCostCenter, data, defaultValues } = this.state
    if (
      !(selectedCompany?.companyName?.length > 0 && selectedCostCenter?.costCenterName?.length) &&
      ObjectHelper.areEqual(data, defaultValues)
    ) {
      this.setState({
        htmlMode: true,
      })
      return
    }
    const { history } = this.props
    if (window.location.pathname.indexOf(`/${this.props.match.params.formId}`) > -1) {
      history.push(`/requests/${this.props.match.params.formId}/view=html`)
      this.setState({
        htmlMode: true,
      })
    } else {
      history.push(`/requests/${this.props.match.params.orderId}/view=html`)
      this.setState({
        htmlMode: true,
      })
    }
    if (this.state.stepApprovedDownload.visible) {
      const stepApprovedDownload: IAlertState = {
        ...this.state.stepApprovedDownload,
        visible: !this.state.stepApprovedDownload.visible,
      }
      this.setState({
        stepApprovedDownload,
      })
    }
  }

  private sortCostCenters() {
    const timeStamp = new Date().getTime()

    const { externalDataDict } = this.state
    const { t } = this.props

    const { selectedCompany } = this.state

    const costCenterList = this.getCostCentersByCompany(selectedCompany?.companyId).sort((a, b) => {
      if (!a.name && !b.name) return 0
      if (!a.name) return 1
      if (!b.name) return -1
      return a.name.localeCompare(b.name)
    })

    const noCostCentersForCompany = !!selectedCompany?.companyId && costCenterList.length === 0

    const unitsSelect: IExternalDataItem = {
      timeStamp,
      data: {},
    }

    costCenterList.forEach((u) => {
      unitsSelect.data[u.id] = u.name || t('NO_COST_CENTER')
    })

    this.setState((prev) => ({
      externalDataDict: { ...prev.externalDataDict, unitsSelect },
      costCenterList,
      noCostCentersForCompany,
    }))
  }

  private getCostCentersByCompany(companyId: string): UnitAccountViewModel[] {
    const costCenterList: UnitAccountViewModel[] = []

    if (companyId) {
      const customers =
        this.props.user?.isInternalUser && this.state.currentForm?.ownerTenant
          ? this.props.customers.filter((c) => !c.tenantId || c.tenantId === this.state.currentForm.ownerTenant)
          : this.props.customers

      const filteredCustomers = customers?.filter((c) => c.id === companyId)

      const now = new Date()
      for (const c of filteredCustomers ?? []) {
        for (const u of c.units ?? []) {
          const validFrom = u.validFrom ? new Date(u.validFrom) : undefined
          const validTo = u.validTo ? new Date(u.validTo) : undefined
          if ((validFrom && validFrom > now) || (validTo && validTo < now)) {
            continue
          }

          costCenterList.push(u as unknown as UnitAccountViewModel)
        }
      }
    }

    return costCenterList
  }

  private exportToPDF() {
    const { currentOrder, orderForms } = this.state
    const { i18n, t } = this.props
    if (currentOrder) {
      Orders.exportOrder(currentOrder, orderForms, i18n.language, t)
    }
  }

  private searchStringDeleted() {
    const timeStamp = new Date().getTime()
    this.setState((prev) => ({
      externalDataDict: {
        ...prev.externalDataDict,
        currentVehicleID: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleDriverName: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleDriverCountry: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleDriverLang: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleDriverFirstName: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleDriverLastName: {
          timeStamp,
          data: { nothing: '' },
        },
        currentVehicleDriverAddress: {
          timeStamp,
          data: { nothing: '' },
        },
        currentVehicleDriverPhoneNumber: {
          timeStamp,
          data: { nothing: '' },
        },
        currentVehicleDriverEmail: {
          timeStamp,
          data: { nothing: '' },
        },
        currentVehicleReturnDate: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleLicensePlate: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleBrand: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleModel: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
        currentVehicleContractRef: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
      },
    }))
  }

  private handleDocumentClick(e: MouseEvent) {
    const eventTarget = e.target as HTMLElement | null
    if (
      this.customerSearchRef.current &&
      this.customerSearchRef.current.contains(eventTarget) &&
      eventTarget?.className !== 'icon-up'
    ) {
      this.setState({
        customersListDispaly: true,
      })
      return
    }
    if (
      !this.customerSearchRef?.current?.contains(eventTarget) ||
      (this.customerSearchRef?.current?.contains(eventTarget) && eventTarget?.className === 'icon-up')
    ) {
      this.setState({
        customersListDispaly: false,
      })
    }
  }

  private companySearchHandle(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value.length === 0) {
      this.setState({
        companySearchString: '',
        selectedCompany: {
          companyId: '',
          companyName: '',
        },
      })
    } else {
      this.setState({
        companySearchString: e.target.value,
      })
    }
  }

  private userChangeHandle(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      currentUser: e.target.value.replace(/  +/g, ' '),
    })
  }

  private selectedCompany(e: CustomerViewModel) {
    const addresses: AddressModel[] =
      e.primary?.addresses.filter((a) => a.kind === AddressKind.Invoice || e.kind === AddressKind.Primary) ?? []

    this.setState({
      selectedCompany: {
        companyId: e.id,
        companyName: e.name,
      },
      customerAddresses: addresses,
      companySearchString: e.name,
    })
  }

  private selectedCompanyById(id: string) {
    this.props.customers.forEach((obj) => {
      if (obj.id === id) {
        this.setState({
          selectedCompany: {
            companyId: obj.id,
            companyName: obj.name,
          },
        })
      }
    })
  }

  private selectedCostCenter(e: React.ChangeEvent<HTMLSelectElement>) {
    const { t } = this.props
    this.props.customers.map((obj) => {
      obj.units?.map((el) => {
        if (el.id === e.target.value) {
          this.setState({
            selectedCostCenter: {
              costCenterId: el.id,
              costCenterName: el.name || t('NO_COST_CENTER'),
            },
          })
        }
      })
    })
  }

  private selectedCostCenterById(id: string) {
    const { t } = this.props
    const ids = id.split('/')

    id = ids[ids.length - 1]

    this.props.customers.map((obj) => {
      obj.units?.map((el) => {
        if (el.id === id) {
          this.setState({
            selectedCostCenter: {
              costCenterId: el.id,
              costCenterName: el.name || t('NO_COST_CENTER'),
            },
          })
        }
      })
    })
  }

  private showUnits() {
    const timeStamp = new Date().getTime()
    const companies: IExternalDataItem = {
      timeStamp,
      data: {},
    }
    const units: IExternalDataItem = {
      timeStamp,
      data: {},
    }
    const user: IExternalDataItem = {
      timeStamp,
      data: {
        name: this.props.user?.displayName ?? '',
      },
    }

    this.props.customers.forEach((obj) => {
      companies.data[obj.name] = obj.name
      if (!this.state.currentCompanyName || obj.name === this.state.currentCompanyName) {
        obj.units?.forEach((unit) => {
          const unitName = unit.name || this.props.t('NO_COST_CENTER')

          units.data[unitName] = unitName
        })
      }
    })
    this.setState((prev) => ({
      externalDataDict: { ...prev.externalDataDict, companies, units, user },
    }))
  }

  private closeApprovedRequest() {
    const nothingToApprove: IAlertState = {
      ...this.state.nothingToApprove,
      visible: !this.state.nothingToApprove.visible,
    }
    this.setState({
      nothingToApprove,
    })
  }

  private toggleAlert() {
    const deleteAlertState: IAlertState = {
      ...this.state.deleteAlertState,
      visible: !this.state.deleteAlertState.visible,
    }
    this.setState({
      deleteAlertState,
    })
  }

  private closeUpdatedStep() {
    const alreadyUpdatedStepAlert: IAlertState = {
      ...this.state.alreadyUpdatedStepAlert,
      visible: !this.state.alreadyUpdatedStepAlert.visible,
    }
    this.setState({
      alreadyUpdatedStepAlert,
    })
    this.props.history.push('/requests')
  }

  private closeDeletedAlert() {
    const requestWasDeletedAlert: IAlertState = {
      ...this.state.requestWasDeletedAlert,
      visible: !this.state.requestWasDeletedAlert.visible,
    }
    this.setState({
      requestWasDeletedAlert,
    })
    this.props.history.push('/requests')
  }

  private toggleAlert2() {
    const reasonRequiredAlertState: IAlertState = {
      ...this.state.reasonRequiredAlertState,
      visible: !this.state.reasonRequiredAlertState.visible,
    }
    this.setState({
      reasonRequiredAlertState,
    })
  }

  private toggleAlert3() {
    const approvalStepFailAlertState: IAlertState = {
      ...this.state.approvalStepFailAlertState,
      visible: !this.state.approvalStepFailAlertState.visible,
    }
    this.setState({
      approvalStepFailAlertState,
    })
  }

  private handleConfirmClose(confirm: boolean) {
    const { currentOrder } = this.state
    if (confirm && currentOrder?.approvalProcessId) {
      this.setState({
        approveConfirmed: true,

        approversLoading: true,
        loading: true,
      })

      const nextPendingStep = currentOrder.approvalProcess?.steps
        ?.toSorted((a, b) => a.step - b.step)
        ?.filter((s) => s.status === approvalStepsStatuses.pending)[0]?.step
      const data = {
        decline: false,
        note: this.state.noteValueToPost,
        step: nextPendingStep || 0,
      }
      if (currentOrder) {
        this.props.postNextApprovalProcessStep(currentOrder.approvalProcessId, data).then(
          (approvalProcess) => {
            this.setState({ noteValueToPost: '', loading: false, approversLoading: false, approvalProcess })
          },
          () => {
            this.handleFailedApprovalStep()
          }
        )
      }
    }
    this.setState({
      showApproveConfirm: false,
    })
  }

  private locationsPrefill(zipCode: string, locationRaw: string) {
    const location = this.state.locations.find((el) => el.postcode === zipCode && el.town === locationRaw)
    const timeStamp = new Date().getTime()
    const townFromLocation: IExternalDataItem = {
      timeStamp,
      data: {},
    }
    const cantonFromLocation: IExternalDataItem = {
      timeStamp,
      data: {},
    }

    if (location) {
      townFromLocation.data[location.town] = location.town
    } else {
      townFromLocation.data[zipCode] = ''
    }

    if (location?.canton?.code) {
      cantonFromLocation.data[location.canton.code] = location.canton.code
    } else {
      cantonFromLocation.data[zipCode] = ''
    }

    this.setState((prev) => ({
      externalDataDict: {
        ...prev.externalDataDict,
        townFromLocation,
        cantonFromLocation,
      },
    }))
  }

  private removeCompanyAddress() {
    const timeStamp = new Date().getTime()
    this.setState((prev) => ({
      externalDataDict: {
        ...prev.externalDataDict,
        companyAddresses: {
          timeStamp,
          data: {
            nothing: '',
          },
        },
      },
    }))
  }

  private prefillManagerContacts(manager?: ManagerModel) {
    const timeStamp = new Date().getTime()
    if (!manager) {
      this.setState((prev) => ({
        externalDataDict: {
          ...prev.externalDataDict,
          contactFullName: {
            timeStamp,
            data: {
              nothing: '',
            },
          },
          contactEmail: {
            timeStamp,
            data: {
              nothing: '',
            },
          },
          contactPhoneNumber: {
            timeStamp,
            data: {
              nothing: '',
            },
          },
          contactAddress: {
            timeStamp,
            data: {},
          },
        },
      }))
    } else {
      const contactFullName: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const contactEmail: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const contactPhoneNumber: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const contactAddress: IExternalDataItem = {
        timeStamp,
        data: {},
      }

      if (manager.displayName) contactFullName.data[manager.displayName] = manager.displayName

      if (Arr.any(manager.contacts)) {
        manager.contacts?.filter((el) => {
          if (el.kind === ContactKind.Email && el.value) {
            contactEmail.data[el.value] = el.value
          }
          if (el.kind === ContactKind.PhoneNumber && el.value) {
            contactPhoneNumber.data[el.value] = el.value
          }
        })
      } else {
        contactEmail.data['nothing'] = ''
        contactPhoneNumber.data['nothing'] = ''
      }
      if (Arr.any(manager.addresses)) {
        manager.addresses?.filter((el) => {
          const fullAddress = `${el.street} ${el.postalCode} ${el.city} ${el.country}`
          contactAddress.data[fullAddress] = fullAddress
        })
      } else {
        contactAddress.data = {}
      }

      this.setState((prev) => ({
        externalDataDict: {
          ...prev.externalDataDict,
          contactFullName,
          contactEmail,
          contactPhoneNumber,
          contactAddress,
        },
      }))
    }
  }

  private loadManagers() {
    this.props
      .loadCustomersManagers(this.state.selectedCompany.companyId)
      .then((res) => this.collectManagers(res, this.state.selectedCompany.companyId))
  }

  private collectManagers(managers: ManagerModel[], companyId: string) {
    const foundCustomer = this.props.customers.find((q) => q.id === companyId)
    const managersClone = ObjectHelper.clone(managers).map((m) => ({ ...m, ccNames: [] as string[] }))
    managersClone.forEach((el) => {
      foundCustomer?.units.forEach((q) =>
        q.managers?.forEach((z) => {
          if (z.displayName === el.displayName && ObjectHelper.areEqual(z.addresses, el.addresses)) {
            el.ccNames.push(q.name)
          }
        })
      )
    })
    this.setState({ customerManagers: managersClone })
  }

  private loadContractAndPrefill(contractId: string, setCompanyAndCostCenter?: boolean) {
    if (setCompanyAndCostCenter) {
      this.setState({
        loading: true,
      })
    }

    this.props.loadContract(contractId).then((contract) => {
      const timeStamp = new Date().getTime()
      const currentVehicleID: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleLicensePlate: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleReturnDate: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleBrand: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleModel: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverName: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleContractRef: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverCountry: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverLang: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverFirstName: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverLastName: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverAddress: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverPhoneNumber: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const currentVehicleDriverEmail: IExternalDataItem = {
        timeStamp,
        data: {},
      }
      const vehicle = contract.vehicle
      const imposedReturnDate = contract.imposedReturnDate ? printDate(contract.imposedReturnDate) : undefined
      const driver = vehicle?.driver
      const driverEmail = driver?.contacts.find((q) => q.kind === ContactKind.Email)?.value
      const driverAddress = this.fullAddress(driver?.addresses.find((q) => q.kind === AddressKind.Primary))
      const driverPhoneNumber = driver?.contacts.find((q) => q.kind === ContactKind.PhoneNumber)?.value
      if (driverEmail) currentVehicleDriverEmail.data[driverEmail] = driverEmail
      if (driverAddress) currentVehicleDriverAddress.data[driverAddress] = driverAddress
      if (driverPhoneNumber) currentVehicleDriverPhoneNumber.data[driverPhoneNumber] = driverPhoneNumber
      if (driver?.country) currentVehicleDriverCountry.data[driver.country] = driver.country
      if (driver?.language) currentVehicleDriverLang.data[driver.language] = driver.language
      if (driver?.firstName) currentVehicleDriverFirstName.data[driver.firstName] = driver.firstName
      if (driver?.lastName) currentVehicleDriverLastName.data[driver.lastName] = driver.lastName
      if (vehicle?.externalReference)
        currentVehicleID.data[vehicle.externalReference] = vehicle.externalReference.includes(':')
          ? vehicle.externalReference.split(':')[1]
          : vehicle.externalReference
      if (vehicle?.licensePlate?.licenseNumber)
        currentVehicleLicensePlate.data[vehicle.licensePlate.licenseNumber] = vehicle.licensePlate.licenseNumber
      if (imposedReturnDate) currentVehicleReturnDate.data[imposedReturnDate] = imposedReturnDate
      if (driver?.displayName) currentVehicleDriverName.data[driver.displayName] = driver.displayName
      if (vehicle?.makeName) currentVehicleBrand.data[vehicle.makeName] = vehicle.makeName
      if (vehicle?.modelName) currentVehicleModel.data[vehicle.modelName] = vehicle.modelName
      if (contract.reference) currentVehicleContractRef.data[contract.reference] = contract.reference

      if (setCompanyAndCostCenter) {
        this.setState({
          loading: false,
        })

        const companyAndUnit = contract?.owner?.replace('$', '')?.toLowerCase()?.split('//')

        if (companyAndUnit && companyAndUnit[0]) {
          this.selectedCompanyById(companyAndUnit[0])
        }

        if (companyAndUnit && companyAndUnit[1]) {
          setTimeout(() => {
            this.selectedCostCenterById(companyAndUnit[1])
          }, 100)
        }
      }

      this.setState((prev) => ({
        externalDataDict: {
          ...prev.externalDataDict,
          currentVehicleID,
          currentVehicleLicensePlate,
          currentVehicleBrand,
          currentVehicleModel,
          currentVehicleContractRef,
          currentVehicleDriverName,
          currentVehicleReturnDate,
          currentVehicleDriverCountry,
          currentVehicleDriverLang,
          currentVehicleDriverFirstName,
          currentVehicleDriverLastName,
        },
      }))
    })
  }

  private fullAddress(addressInfo?: AddressModel) {
    if (addressInfo) {
      const address = `${addressInfo?.street} ${addressInfo?.postalCode} ${addressInfo?.city} ${addressInfo?.country}`
      return address
    } else {
      return ''
    }
  }

  private sendDecline() {
    this.setState({ loading: true, approversLoading: true })
    const pendingSteps =
      this.state.currentOrder.approvalProcess?.steps?.filter((el) => el.status === ApprovalProcessStepStatus.Pending) ??
      []
    const reasonEntered = this.state.noteValueToPost.length > 2

    if (!reasonEntered) {
      this.setState({
        reasonRequiredAlertState: {
          visible: true,
          message: this.props.t('DECLINE_REQUIREES_A_REASON'),
          title: this.props.t('ERROR'),
        },
        loading: false,
        approversLoading: false,
        requiredField: true,
        showDeclineReasonValidation: true,
      })
      return
    }

    this.props.getOrder(this.state.currentOrder.id).then(
      (latestOrderVersion) => {
        this.setState({
          currentSection: 'approve',
          loading: false,
          approversLoading: false,
          orders: [latestOrderVersion],
        })
        const newPendingSteps =
          latestOrderVersion.approvalProcess?.steps?.filter((el) => el.status === ApprovalProcessStepStatus.Pending) ??
          []
        if (pendingSteps.length !== newPendingSteps.length) {
          this.setState({
            alreadyUpdatedStepAlert: {
              title: this.props.t('WARNING'),
              message: this.props.t('ANOTHER_USER_HAS_ALREADY_UPDATED_THE_REQUEST'),
              visible: true,
            },
          })
          return
        } else if (this.state.currentOrder) {
          this.setState({
            showDeclineConfirm: true,
          })
        }
      },
      (err) => {
        this.setState({ loading: false, approversLoading: false })
        if (err.status === 410) {
          this.setState({
            requestWasDeletedAlert: {
              title: this.props.t('WARNING'),
              message: this.props.t('REQUEST_NOT_FOUND_OR_DELETED'),
              visible: true,
            },
          })
          return
        } else {
          return
        }
      }
    )
  }

  private showConfirm() {
    this.setState({ loading: true, approversLoading: true })
    const pendingSteps =
      this.state.currentOrder.approvalProcess?.steps?.filter((el) => el.status === ApprovalProcessStepStatus.Pending) ??
      []
    this.props.getOrder(this.state.currentOrder.id).then(
      (latestOrderVersion) => {
        this.setState({
          currentSection: 'approve',
          loading: false,
          orders: [latestOrderVersion],
          approversLoading: false,
        })
        const newPendingSteps =
          latestOrderVersion.approvalProcess?.steps?.filter((el) => el.status === ApprovalProcessStepStatus.Pending) ??
          []
        if (pendingSteps.length !== newPendingSteps.length) {
          this.setState({
            alreadyUpdatedStepAlert: {
              title: this.props.t('WARNING'),
              message: this.props.t('ANOTHER_USER_HAS_ALREADY_UPDATED_THE_REQUEST'),
              visible: true,
            },
          })
          return
        } else {
          this.setState({
            showApproveConfirm: true,
          })
        }
      },
      (err) => {
        this.setState({ loading: false, approversLoading: false })
        if (err.status === 410) {
          this.setState({
            requestWasDeletedAlert: {
              title: this.props.t('WARNING'),
              message: this.props.t('REQUEST_NOT_FOUND_OR_DELETED'),
              visible: true,
            },
          })
          return
        } else {
          return
        }
      }
    )
  }

  private saveNoteValue(e: React.ChangeEvent<HTMLTextAreaElement>) {
    const { showDeclineReasonValidation } = this.state
    const noteValueToPost = e.target.value
    this.setState({
      noteValueToPost,
      showDeclineReasonValidation: showDeclineReasonValidation ? (noteValueToPost?.length > 2 ? false : true) : false,
    })
  }

  private initFormByOrder(orderId: string, orders: OrderViewModel[], orderForms: OrdersFormViewModel[]) {
    const foundOrder = orders.find((or) => or.id === orderId)
    const currentForm = foundOrder ? orderForms.find((f) => f.id === foundOrder.formId) : undefined

    this.setState({
      currentUser: foundOrder?.userDisplayName || '',
      selectedCompany: foundOrder?.company || {
        companyName: '',
        companyId: '',
      },
    })

    if (!!foundOrder && !!currentForm) {
      const order = {
        ...foundOrder,
      }

      const { user } = this.props

      if (currentForm) {
        this.fillFormWithOrderDataInt(currentForm, order)
      }
      if (order?.approvalProcess) {
        const pendingSteps =
          order?.approvalProcess?.steps?.filter((s) => s.status === approvalStepsStatuses.pending) ?? []

        pendingSteps.sort((a, b) => a.step - b.step)
        if (pendingSteps.length > 0) {
          this.setState({
            loading: true,
            approversLoading: true,
          })

          const pendingStep = pendingSteps[0]
          const approvalStepType =
            pendingStep.stepType === ApprovalProcessStepKind.BusinessUnit
              ? ApprovalStepTypeEnum.BU
              : pendingStep.stepType === ApprovalProcessStepKind.Company
              ? ApprovalStepTypeEnum.COM
              : ApprovalStepTypeEnum.DEFAULT

          const approverIdsPromise = user?.tenant
            ? this.props.getRequestApproverIds(user.tenant, {
                owners: pendingStep.owners || [],
                userBusinessUnitId: order?.costCenter?.costCenterId,
                userCompanyId: order?.company?.companyId,
                approvalStepType,
              })
            : Promise.resolve([])
          approverIdsPromise.then(
            (resp) => {
              const canApproveOrder =
                !!resp &&
                !!resp.length &&
                !!user?.id &&
                resp.includes(user.id) &&
                PermissionManager.canApproveRequests(user)

              if (this.state.currentOrder?.approvalProcess?.steps?.length) {
                const currentStep = this.state.currentOrder?.approvalProcess?.steps?.filter(
                  (obj) => obj.status !== 'Pending'
                ).length
                if (!canApproveOrder) {
                  this.state.currentOrder.approvalProcess.steps.forEach((step, i) => {
                    step.owners.forEach((u) => {
                      if (
                        u === user?.id &&
                        this.state.currentOrder?.approvalProcess?.steps?.[i].status !== 'Pending' &&
                        i !== currentStep
                      ) {
                        if (this.state.currentOrder?.approvalProcess?.steps?.[i].status === 'Approved') {
                          this.setState({
                            nothingToApprove: {
                              message: this.props.t('SELECTED_REQUEST_ALREADY_APPROVED'),
                              title: this.props.t('INFORMATION'),
                              visible: true,
                            },
                          })
                        }
                        if (this.state.currentOrder?.approvalProcess?.steps?.[i].status === 'Declined') {
                          this.setState({
                            nothingToApprove: {
                              message: this.props.t('SELECTED_REQUEST_ALREADY_DECLINED'),
                              title: this.props.t('INFORMATION'),
                              visible: true,
                            },
                          })
                        }
                      }
                    })
                  })
                }
              }
              this.setState({
                loading: false,
                approversLoading: false,
                canApproveOrder,
              })
            },
            () => {
              this.setState({
                loading: false,
                approversLoading: false,
              })
            }
          )
        }
      }
    }
  }

  private handleApprovalProcessConfigChage(e: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({
      currentApprovalWorflowConfigId: e.target.value,
    })
  }

  private fillFormWithOrderData() {
    const { currentForm, orders } = this.state
    if (!currentForm) return
    const order = orders.find(
      (or) => or.formId === currentForm.id && (!or.approvalProcessId || or.approvalProcessId === emptyGuid)
    )
    this.fillFormWithOrderDataInt(currentForm, order)
  }

  private fillFormWithOrderDataInt(currentForm: OrdersFormViewModel, order?: OrderViewModel) {
    if (!order) {
      return
    }
    this.setState({
      fieldsWithAppliedInternalSource: ObjectHelper.clone(currentForm.formFields),
    })

    let data: Partial<Record<string, string>> = {}

    currentForm.formFields.forEach((field) => {
      const { name } = field
      if (order.data[name]) {
        data[name] = order.data[name]
      }
      if (order.data[name] == null) {
        data[name] = undefined
      }

      data = this.getFieldIfExistFromInternalSource(field, data, true)
    })

    this.setState({
      data,
      currentForm,
      currentOrder: order,
      currentApprovalWorflowConfigId: order?.approvalProcessConfigId,
      formReadOnly:
        !this.props.user?.canManageOrders || !!order?.approvalProcess?.id || order.userId !== this.props.user?.id,
    })
  }

  private loadFormOrder(orderId: string) {
    const { history } = this.props
    this.setState({
      loading: true,
    })
    this.props.getOrder(orderId).then(
      (res) => {
        this.setState({ orders: [res] })
        this.props.getOrdersForm(res.formId).then(
          (form) => {
            this.setState({
              htmlMode: this.props.location.pathname.includes('/view=html'),
              dcsMode: this.props.location.pathname.includes('/view=dcs'),
              pdfExport: this.props.location.pathname.includes('/view=pdf'),
              loading: false,
              orderForms: [form],
            })
          },
          () => {
            this.setState({
              loading: false,
            })
          }
        )
      },
      (err) => {
        if (err.status === 410) {
          this.setState({
            loading: false,
            requestWasDeletedAlert: {
              title: this.props.t('WARNING'),
              message: this.props.t('REQUEST_NOT_FOUND_OR_DELETED'),
              visible: true,
            },
          })
          return
        }
        history.push(requestsPageUrl)
        if (this.props.location.pathname.indexOf('/view=html') > -1) {
          this.setState({
            htmlMode: true,
          })
        }
        if (this.props.location.pathname.indexOf('/view=pdf') > -1) {
          this.setState({
            pdfExport: true,
          })
        }
        this.setState({
          loading: false,
        })
      }
    )
  }

  private sectionHandle(currentSection: string) {
    this.setState({
      currentSection,
    })
  }

  private getReturnLogisticId(
    order: OrderInputModel
  ): Promise<{ logisticId?: string; contractId?: string } | undefined> {
    const { currentForm } = this.state

    const isReturnOrder =
      currentForm?.returnOrderWorkflowId &&
      (!currentForm?.returnOrderConditions ||
        !Object.keys(currentForm.returnOrderConditions).length ||
        Object.keys(currentForm.returnOrderConditions).some(
          (k) => order.data[k]?.toLowerCase() === currentForm.returnOrderConditions?.[k]?.toLowerCase()
        ))

    const contractRefField = currentForm?.formFields.find(
      (f) => f.externalDataSourceName === 'currentVehicleContractRef'
    )

    if (!isReturnOrder || !contractRefField || !contractRefField.name) {
      return Promise.resolve(undefined)
    }

    const contractRef = order.data[contractRefField.name]

    if (!contractRef || contractRef.length < 3) {
      return Promise.resolve(undefined)
    }

    return this.props.searchContracts(contractRef, true).then(
      (contracts) => {
        const match = contracts.find((c) => c.reference === contractRef)

        const gallikerReference = match?.vehicle?.['GallikerReference']
        const parts = gallikerReference ? gallikerReference.split('-') : []

        let logisticId: string | undefined = undefined

        if (parts.length === 2) {
          logisticId = `${parts[0]}-${parts[1]}R`
        } else if (parts.length === 3) {
          logisticId = `${parts[0]}-${parts[1]}${parts[2]}R`
        }

        return Promise.resolve({ logisticId, contractId: match?.id })
      },
      () => {
        return Promise.resolve(undefined)
      }
    )
  }

  private handleSubmit(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, final?: boolean) {
    const {
      currentForm,
      currentOrder,
      data,
      currentApprovalWorflowConfigId,
      selectedCompany,
      selectedCostCenter,
      currentUser,
      availableApprovalProcesses,
      availableApprovalProcessesAdv,
      filterCompamniesByMatchingApprovalFlows,
      fieldVisibility,
      noCostCentersForCompany,
      validationErrors,
    } = this.state
    event.preventDefault()

    if (!currentForm) return

    if (final) {
      this.setState({
        submitFired: true,
      })

      const skipTypesForValidation = ['label']

      const notFilledRequiredFieldsFound =
        currentForm.formFields.filter(
          (f) => !skipTypesForValidation.includes(f.type) && f.required && !!fieldVisibility[f.name] && !data[f.name]
        ).length > 0 ||
        currentForm.formFields.filter(
          (f) =>
            !skipTypesForValidation.includes(f.type) &&
            f.required &&
            !!fieldVisibility[f.name] &&
            f.type === 'checkBox' &&
            data[f.name] === 'false'
        ).length > 0

      if (
        notFilledRequiredFieldsFound ||
        Object.values(validationErrors).some((e) => e?.length) ||
        !selectedCompany?.companyName ||
        (!noCostCentersForCompany && !selectedCostCenter?.costCenterName) ||
        !currentUser
      ) {
        this.setState({
          deleteAlertState: {
            visible: true,
            message: this.props.t('REQUIRED_FIELDS_ARE_NOT_FILLED'),
            title: this.props.t('ERROR'),
          },
          requiredField: true,
        })

        const sectionsDict = { ...this.state.sectionsDict }
        const formfields: string[] = []
        const formfieldsOK: string[] = []
        currentForm.formFields.map((s) => {
          if (
            (s.required && !data[s.name]) ||
            (s.required && s.type === 'checkBox' && data[s.name] !== 'true') ||
            validationErrors[s.name]?.length
          ) {
            Object.keys(s.visibleWhen).map((el) => {
              const val = data[el]
              if ((val && s.visibleWhen[el].includes(val)) || !el) {
                formfields.push(s.section)
              }
            })
            if (Object.keys(s.visibleWhen).length === 0) {
              formfields.push(s.section)
            }
          }
        })
        currentForm.formFields.map((s) => {
          if (s.required && data[s.name] && formfields.indexOf(s.section) <= -1) {
            formfieldsOK.push(s.section)
          }
        })
        formfields.filter((value, index, self) => self.indexOf(value) === index).map((el) => (sectionsDict[el] = true))

        formfieldsOK
          .filter((value, index, self) => self.indexOf(value) === index)
          .map((el) => (sectionsDict[el] = false))
        this.setState({
          sectionsDict,
        })
        return
      }
    }

    const availableApprovalProcessesToUse =
      availableApprovalProcessesAdv.length > 0
        ? availableApprovalProcessesAdv
        : availableApprovalProcesses.filter((el) => !currentForm.approvalWorkflowsAdv[el.id])

    this.setState({
      loading: true,
    })
    const model: OrderInputModel = {
      formId: currentForm.id,
      data: data as Record<string, string>,
      company: currentOrder?.company,
      costCenter: currentOrder?.costCenter,
      approvalProcessConfigId:
        !!currentApprovalWorflowConfigId && currentApprovalWorflowConfigId !== emptyGuid
          ? currentApprovalWorflowConfigId
          : availableApprovalProcessesToUse.find(
              (ap) => !filterCompamniesByMatchingApprovalFlows || ap.validCompanies?.length
            )?.id,
    }

    this.getReturnLogisticId(model).then((ret) => {
      if (final) {
        model.returnLogisticId = ret?.logisticId
        model.returnContractId = ret?.contractId
      }
      const promise = currentOrder?.id
        ? this.props.putOrder(currentOrder.id, model, final)
        : this.props.postOrder(model, final)
      promise.then(
        () => {
          this.setState({
            loading: false,
          })
          this.props.history.push(requestsPageUrl)
        },
        (e) => {
          if (e.isApiException) {
            const apiError = e as ApiException
            if (apiError.response.includes('ReturnLogisticId')) {
              this.handleReturnOrderConflict()
            }
          }
          this.setState({
            loading: false,
          })
        }
      )
    })
  }

  private changeFile(
    form: OrdersFormViewModel,
    data: Partial<Record<string, string>>,
    name: string,
    event: File,
    tooBig?: boolean
  ) {
    if (tooBig) {
      this.setState({
        deleteAlertState: {
          visible: true,
          message: this.props.t('TOO_HEAVY_FILE'),
          title: this.props.t('ERROR'),
        },
      })
      return
    }

    const reader = new FileReader()
    const fileName = event.name
    reader.onload = () => {
      const dataUrl = reader.result
      const value = fileName + '|' + dataUrl
      data[name] = value
      this.setState({
        currentForm: form,
      })
    }
    reader.readAsDataURL(event)
  }

  private updateFuelCards(fc: FuelCardViewModel[], maxFuelCards = 0) {
    const timeStamp = new Date().getTime()
    const fuelSelect: IExternalDataItem = {
      timeStamp,
      data: {},
      tr: {},
      misc: {},
    }
    fc.forEach((el) => {
      const miscData = (el.electric ? 'electric' : '') + ' ' + (el.carwash ? 'carwash' : '')
      fuelSelect.data[el.key] = el.name
      fuelSelect.misc![el.key] = miscData
    })
    this.setState((prev) => ({
      externalDataDict: {
        ...prev.externalDataDict,
        fuelSelect,
      },
      maxFuelCards,
    }))
  }

  private updateFuelCardsFromDefaultSource() {
    this.props.getFuelCards().then((res) => {
      this.updateFuelCards(res)
    })
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps({ appData, customers }: State) {
  return {
    customers: customers.customers,
    user: appData.currentUser,
  }
}

/**
 * What action should be passed to component
 */
const mapDispatchToProps = {
  loadContract: wrapQuery((contractId: string) => contractsApi.endpoints.getContract.initiate(contractId)),
  searchContracts: wrapQuery((searchTerm?: string, activeOnly?: boolean) =>
    contractsApi.endpoints.searchContracts.initiate({ searchTerm, activeOnly })
  ),
  getOrdersForm: wrapQuery((formId: string) => ordersApi.endpoints.getOrdersForm.initiate(formId)),
  putOrder: wrapQuery((orderId: string, model: OrderInputModel, final?: boolean) =>
    ordersApi.endpoints.putOrder.initiate({ orderId, final, model })
  ),
  postOrder: wrapQuery((model: OrderInputModel, final?: boolean) =>
    ordersApi.endpoints.postOrder.initiate({ final, model })
  ),
  getFuelCards: wrapQuery(() => ordersApi.endpoints.getFuelCards.initiate()),
  getTenantFuelCardSet: wrapQuery((tenantId: string) =>
    ordersApi.endpoints.getTenantFuelCardSetByTenant.initiate(tenantId)
  ),
  getOrder: wrapQuery((id: string) => ordersApi.endpoints.getOrder.initiate(id)),
  postNextApprovalProcessStep: wrapQuery((processId: string, model: NextApprovalStepInputModel) =>
    ordersApi.endpoints.setNextApprovalProcessStep.initiate({ processId, model })
  ),
  getRequestApproverIds: wrapQuery((tenantId: string, model: ApproverEmailsInputModel) =>
    customersApi.endpoints.getApproverIds.initiate({ tenantId, model })
  ),
  archiveOrder: wrapQuery((id: string) => ordersApi.endpoints.archiveOrder.initiate(id)),
  restoreOrderFromArchive: wrapQuery((id: string) => ordersApi.endpoints.restoreOrderFromArchive.initiate(id)),
  loadCustomersManagers: wrapQuery((customerId: string) =>
    customersApi.endpoints.getCustomerManagers.initiate(customerId)
  ),
  getCantons: wrapQuery(() => locationsApi.endpoints.getCantons.initiate()),
  getLocations: wrapQuery(() => locationsApi.endpoints.getLocations.initiate({})),
}

const connector = connect(mapStateToProps, mapDispatchToProps)
// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(OrdersComponent)) as unknown as React.ComponentType<OwnProps>
